var sUrl = 'https://pyzeleurope.shaperbuddy.com';
var sUrlShop = 'https://pyzeleurope.shaperbuddy.com';

/*
 *
 *	Language Selector
 *
 */
 //var sLang = getQueryString('lang');
 var sLang = "en";

 if( sLang=="" ) sLang="en";

/*
 *	Função para atualizar o URL quando se altera o idioma
 */
 function addOrUpdateUrlParam(uri, paramKey, paramVal) {
 	var re = new RegExp("([?&])" + paramKey + "=[^&#]*", "i");
 	if (re.test(uri)) {
 		uri = uri.replace(re, '$1' + paramKey + "=" + paramVal);
 	} else {
 		var separator = /\?/.test(uri) ? "&" : "?";
 		uri = uri + separator + paramKey + "=" + paramVal;
 	}
 	return uri;
 }

 function getQueryString(name) {
 	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
 	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
 	results = regex.exec(location.search);
 	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
 }

//	Altera o idioma para PT quando se clica em pt
$(document).on("click", "#lang_pt", function(e){
	e.preventDefault();
	if( getQueryString("lang")!="pt" ){
		window.location.href = addOrUpdateUrlParam(window.location.href, "lang", "pt");
	}
})

//	Altera o idioma para EN quando se clica em en
$(document).on("click", "#lang_en", function(e){
	e.preventDefault();
	if( getQueryString("lang")!="en" ){
		window.location.href = addOrUpdateUrlParam(window.location.href, "lang", "en");
	}
})

//	Altera o idioma para EN quando se clica em en
$(document).on("click", "#lang_fr", function(e){
	e.preventDefault();
	if( getQueryString("lang")!="fr" ){
		window.location.href = addOrUpdateUrlParam(window.location.href, "lang", "fr");
	}
})


/* function actualLanguage(element){
 	var lang = element.text().replace('-','').replace(' ','');
 	$.ajax({
		url: sUrl+'/api/v1/language',
		method: 'POST',
		data: '{ "lang":"'+lang+'" }',
		contentType: 'application/json',
		dataType: 'json',
		xhrFields: {
	        withCredentials: true
	    },
		crossDomain: true,
		context: document.body
	}).done(function(data) { 
		window.location.reload();
	}) 	
 }

 $(function(){
 	$.ajax({
		url: sUrl+'/api/v1/language',
		method: 'GET',
		context: document.body
	}).done(function(data) { 
		$('#language-selector ul li a').removeClass('active');
		$('#language-selector ul li a[text='+data.lang+']').addClass('active');
		sLang = data.lang;
	}) 	
 })

 $(document).on('click', '#language-selector ul li a', function(e){
 	e.preventDefault();
 	actualLanguage( $(this) );
 	//setTimeout(function(){ window.location.reload(); }, 1000);
 })*/
/*
 *	end Language Selector
 */

/*
  *	Equalize - Deixar os objetos com o mesmo tamanho (altura)
  */
  $.fn.equalize = function(){
    var maxHeight = 0;
    this.each(function(){
        var _this = $(this);
        if(_this.height() > maxHeight){
        	maxHeight = _this.height();
        }
    });
    return this.each(function(){
        $(this).height(maxHeight);
    });
};
/*
 *	end Equalize
 */

 /*used to populate the mega menu*/
 function service_SurfboardModels(){
 	$.ajax({
 		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {

		//console.log(data);

		$('.mm_0 ul').empty();
		$('.mm_4 ul').empty();
		$('.mm_6 ul').empty();
		for(var key in data) {
			var min_price = data[key].min_price;
			var currency_iso = data[key].currency.iso;
			var currency_symbol = data[key].currency.symbol;
			var waveSize = data[key].wavesize.min;
			var model = data[key].surfboardmodel;
			var boardImg = data[key].img_420;
			var id = data[key].id_surfboardmodel;
			$('.mm_'+waveSize+' ul').append('<li><a href="/boards/detail.php?id='+id+'" data-boardimg="'+boardImg+'" data-min_price="'+min_price+'" data-currencyiso="'+currency_iso+'" data-currencysymbol="'+currency_symbol+'" data-model="'+model+'">'+model+'</a></li>');

			//$('#surfboards-menu-mobile').append('<li><a href="#">'+model+'</a></li>');

			//$('#waves-size-'+waveSize+' li').after().append('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');
			//$('#waves-size').append('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');
			$('#waves-size-'+waveSize).after('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');

			//waves-size-0

			$('.ftws_'+waveSize).append('<li><a href="/boards/detail.php?id='+id+'">'+model+'</a></li>');
		}
	});
 }



 function service_SurfboardModels_widget(){
 	$.ajax({
 		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {
 		for(var key in data) {
 			var id_surfboardmodel = data[key].id_surfboardmodel;
 			var waveSize = data[key].wavesize.min;
 			var model = data[key].surfboardmodel;
 			var boardImg = data[key].img_303;
 			var symbol = data[key].currency.symbol;
 			var iso = data[key].currency.iso;
 			var minPrice = data[key].min_price;
 			var latestModel = data[key].latestmodel;
 			var hasPrice = '';
 			var isNew = '';
 			if(minPrice==''){
 				hasPrice = 'no_price';
 			}
 			if(latestModel==''){
 				isNew = 'not_new';
 			}

            /*
			if(waveSize == '0'){
				$('.featuredboards_track').prepend('															\
					<div class="featb_item">																	\
						<div class="btnnew_wrapper">															\
							<div class="btn btn-warning '+isNew+'">New</div>									\
						</div>																					\
						<a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">							\
							<div class="board_img">																\
								<img src="'+boardImg+'">														\
							</div>																				\
							<div class="board_shadow">															\
								<img src="/images/boardswidget_shadow.png">										\
							</div>																				\
							<div class="board_info">															\
								<span class="board_name">'+model+'</span>										\
								<span class="board_price '+hasPrice+'"><span class="currency_symbol">'+symbol+'</	span>'+minPrice+' '+iso+'</span>	\
							</div>																				\
						</a>																					\
					</div>																						\
				');
				*/
			//} else {
				$('.featbsep_'+waveSize).after('																\
					<div class="featb_item">																	\
					<div class="btnnew_wrapper">															\
					<div class="btn btn-warning '+isNew+'">New</div>									\
					</div>																					\
					<a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">							\
					<div class="board_img">																\
					<img src="'+boardImg+'">														\
					</div>																				\
					<div class="board_shadow">															\
					<img src="/images/boardswidget_shadow.png">										\
					</div>																				\
					<div class="board_info">															\
					<span class="board_name">'+model+'</span>										\
					<span class="board_price '+hasPrice+'"><span class="currency_symbol">'+symbol+'</span>'+minPrice+' '+iso+'</span>	\
					</div>																				\
					</a>																					\
					</div>																						\
					');
			//}
		}
		var widget = $('.featuredboards_home');
		init_FeaturedBoards(widget);

        // trick to hide the first separator
        $('.featuredboards_track').css('left','-350px');

      });
 }


//populate carousel
function service_homeSliderImg(){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/42/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var imgContainer = $('.main_destaque .carousel-inner');
		var bulletContainer = $('.main_destaque .carousel-indicators')
		//imgContainer.empty();
		bulletContainer.empty();
		var keyI = 0;
		for(var key in data) {

			//check if link exists
			if( data[key].hpurl != null ) link = data[key].hpurl;
			else link = '#';

			//--------------------------------------------------------
			//build html here

			//manipulate for testing purposes - it works
			//data[key].hpurl = 'http://www.surftotal.com';

			var item = '<div class="item">';

			//open link if it exists
			if( data[key].hpurl != null ){
				item += '<a href="'+data[key].hpurl+'">';
			}

			item += '<img src="'+data[key].bannerimg+'" alt="'+data[key].hpresume+'"> \
			<div class="carousel-caption"></div>				\
			<div class="carousel-caption">					\
			<p class="hpslidertext_1">'+data[key].hptitle+'</p>					\
			<p class="hpslidertext_2">'+data[key].hpresume+'</p>';

			//close link, if it exists..
			if( data[key].hpurl != null ){
				item += '</a>';
			}

			item += '</div>\
			</div>';

			//console.log(item);

			//finish building html
			//--------------------------------------------------------

			//append html
			imgContainer.append(item);

			bulletContainer.append('<li data-target="#chilli_carousel" data-slide-to="'+keyI+'"></li>');

			keyI++;

		}

		imgContainer.find('.item:first').addClass('active');
		bulletContainer.find('li:first').addClass('active');

		setTimeout(function(){
			$('.main_destaque').removeClass('md_loadingimgs');
		}, 200);

	});
}



function service_homeLinksDestaque(){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/43/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		$('.links_destaque .ld_1 a img').attr('src', data[0].hpthumb);
		$('.links_destaque .ld_1 .ld_item_title').text(data[0].hpresume);
		$('.links_destaque .ld_1 a').attr('href', data[0].hpurl);
		$('.links_destaque .ld_1 a .lditem_toplayer p').html(data[0].hptitle);
		$('.links_destaque .ld_2 a img').attr('src', data[1].hpthumb);
		$('.links_destaque .ld_2 .ld_item_title').text(data[1].hpresume);
		$('.links_destaque .ld_2 a').attr('href', data[1].hpurl);
		$('.links_destaque .ld_2 a .lditem_toplayer p').html(data[1].hptitle);
	});
}


//home video
function service_homeVideo(){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/44/objects?top=1&lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log(data);

        //throw new Error('exiting');

        $('#video-title').text(data[0].hptitle);
        $('#video-date').append(data[0].dt_publication.en);

        var isYoutube = data[0].hpurlvideo.indexOf('youtu') > -1;
        if(isYoutube){
        	videoId = youtube_parser(data[0].hpurlvideo);
        	videoSource = 'youtube';
        } else {
        	var vimeoId = data[0].hpurlvideo.split('/');
        	videoId = vimeoId[vimeoId.length - 1];
        	videoSource = 'vimeo';
        	videoUrl = 'https://player.vimeo.com/video/'+videoId;
        }

        if(videoSource=='vimeo'){
        	videoHtml = '<iframe src="https://player.vimeo.com/video/'+videoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        } else if(videoSource=='youtube'){
        	videoHtml = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
        }
        $('.video_home_video').append(videoHtml);
      });
}



function service_homeNews(id_team){
	var url = sUrl+'/api/v1/cms/zones/45/objects?lang='+sLang;
	if(id_team!=undefined){
		url += '&id_team='+id_team;
	}

	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var length = data.length;
		var container = $('.lfc_articles_container');
		container.empty();
		for(i=0;i<3;i++){
			var multimediaType = data[i].multimedia[0].id_cmsconteudomultimediatype;
			var fileUrl = data[i].multimedia[0].filename;
			var title = data[i].hptitle;
			var pubDate = data[i].dt_publication.en;
			var resume = data[i].hpresume;
			var id_cmsconteudo = data[i].id_cmsconteudo;


			container.append('																	\
				<div class="col-sm-4 lfc_article_wrapper lfca_'+i+'">							\
				<div class="lfc_article">													\
				<a href="/blog/detail.php?id='+id_cmsconteudo+'">			\
				<div class="lfc_image">												\
				<img src="'+fileUrl+'" class="img-responsive">					\
				<div class="lfc_title">											\
				<p class="lfc_titletitle">'+title+'</p>						\
				</div>															\
				</div>																\
				</a>																	\
				</div>																		\
				</div>																			\
				');


			if(multimediaType === '178'){
				var videoUrl = data[i].multimedia[0].url;
				var isYoutube = videoUrl.indexOf('youtu') > -1;
				if(isYoutube){
					var videoId = youtube_parser(videoUrl);
					fileUrl = 'https://img.youtube.com/vi/'+videoId+'/0.jpg';
					$('.lfca_'+i+' .lfc_article .lfc_image img').attr('src', fileUrl);
				} else {
					var vimeoId = videoUrl.split('/');
					vimeoId = vimeoId[vimeoId.length - 1];
					$('.lfca_'+i).addClass('vimeo_'+vimeoId);
					$.ajax({
						url: 'https://vimeo.com/api/v2/video/'+vimeoId+'.xml',
						method: 'GET',
						context: document.body
					}).done(function(data) {
						var data = $(data);
						var id = data.find('id').text();
						var vimeoFileUrl = data.find('thumbnail_large').text();
						$('.vimeo_'+id).find('.lfc_image img').attr('src', vimeoFileUrl);
					});
				}
			}


		}
	});
}

/*
<div class="col-sm-4 lfc_article_wrapper lfca_'+i+'">							\
	<div class="lfc_article">													\
		<a href="#">															\
			<div class="lfc_image">												\
				<img src="'+fileUrl+'" class="img-responsive">					\
			</div>																\
			<div class="lfc_title">												\
				<p class="lfc_titletitle">'+title+'</p>							\
				<p class="lfc_titleinfo">Posted on: '+pubDate+'</p>				\
			</div>																\
			<div class="lfc_text"><p>'+resume+'</p></div>						\
			<span class="btn btn-primary">View post</span>						\
		</a>																	\
	</div>																		\
</div>
*/




function initInstagram(){
	$('.instaimgs_wrapper').empty();
	$.ajax({
		type: "GET",
		dataType: "jsonp",
		cache: false,
        //url: "https://api.instagram.com/v1/users/12945741/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        //url: "https://api.instagram.com/v1/tags/pyzelsurfboards/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        //this is the token of pictures feed app of user @pedrosilvashaperbuddy
        url: "https://api.instagram.com/v1/users/12945741/media/recent/?access_token=3314912590.dd3641f.b0a044bae2bd4e8688db295404f4d42d",
        success: function(data) {
        	var data = data.data;
        	var iwIndex = 1;
        	$('.instaimgs_wrapper').each(function(){
        		var t = $(this);
        		var nrOfImgs = t.attr('data-nrofimgs');

        		for(var i = 0; i < nrOfImgs; i++){
        			var imgThumb = data[i].images.standard_resolution.url;
        			var imgUrl = data[i].link;
        			t.append('														\
        				<div class="it_item">										\
        				<a href="'+imgUrl+'" target="_blank">					\
        				<img src="'+imgThumb+'" class="img-responsive">		\
        				</a>													\
        				</div>														\
        				');
        		}
        		iwIndex++;
        	});

        	$('.insta_widget').each(function(){
        		var t = $(this);
        		startInstaWidget(t);
        	});
        }
      });
}





function service_Sprayslist(){

    //$('.sbl_boardslist .row').empty();

    var sprays_html = '<div class="row" style="margin-top:50px">';

    $.ajax({
    	url: sUrl+'/api/v1/art/paint?lang='+sLang,
    	method: 'GET',
    	context: document.body
    }).done(function(data) {

        //count the loops to add new rows
        var loops = 0;

        //lazy" data-original="'+img+'"

        for(var key in data) {

        	sprays_html += '<div class="col-sm-4 col-xs-12 text-center spray-paint-col">\
        	<a href="#">\
        	<img class="img-responsive center-block spray-paint-img lazy" data-original="'+data[key].image+'">\
        	<img src="/images/boardswidget_shadow_double.jpg" class="img-responsive center-block">\
        	<div class="board_info">\
        	<span class="board_name">'+data[key].name+'</span>\
        	</div>\
        	</a>\
        	</div>';

        	loops++;

            //close this row and add new row
            if( loops == 3 ){

            	sprays_html += '</div><div class="row" style="margin-top:50px">';

            	loops = 0;

            }

		}//end for

        //close row

        sprays_html += '</div>';

        $('#sprays-container').append( sprays_html );

        //lazy load images only when doc is ready
        $('document').ready(function(){

        	//console.log('doc is ready');

        	$("img.lazy").lazyload({
        		effect : "fadeIn"
        	});
        })

      });

    //open the model and show the spray..
    $(document).on('click', '#sprays-container a', function(e){
    	e.preventDefault();
    	var t = $(this);
    	var imgSrc = t.find('.spray-paint-img').attr('src');
    	var title = t.find('.board_info span').text();
    	$('.spraypimg_wrapper img').attr('src', imgSrc);
    	$('.spraypimg_wrapper_title').text(title);

    	$('#spraypreview').modal('show');

    });

    //fade
    $(document).on('mouseover', '.spray-paint-col', function(){

        //var el = $(this);

        $('.spray-paint-col').not(this).stop().animate({'opacity':.5});

        $(this).on('mouseout', function(){
        	$('.spray-paint-col').not(this).stop().animate({'opacity':1});
        })
      })

  }






  var boardModelList;
  function filterBoards(){
  	$('.sbl_boardslist .sblblboard_item').removeClass('sblblbi_visible');
  	var filterItems = $('.sblf_tabs .tab-pane');
  	var filter = '';
  	var query;
  	var checkedItemsObj = {};

  	var fiIndex = 0;
  	filterItems.each(function(){
  		var t = $(this);
  		var checkedItems = new Array();
  		var tChecked = t.find('.sblf_filtercheck:checked');
  		tChecked.each(function(){
  			var t = $(this);
  			var filterValue = '.'+t.attr('data-filtervalue');
  			checkedItems.push(filterValue);
  		});
  		if(checkedItems.length>0){
  			checkedItemsObj[fiIndex] = checkedItems;
  		} else {
  			checkedItemsObj[fiIndex] = ['none'];
  		}
  		fiIndex++;
  	});

  	function allCombinations(sets,f,context){
  		if (!context) context=this;
  		var p=[],max=sets.length-1,lens=[];
  		for (var i=sets.length;i--;) lens[i]=sets[i].length;
  			function dive(d){
  				var a=sets[d], len=lens[d];
  				if (d==max) for (var i=0;i<len;++i) p[d]=a[i], f.apply(context,p);
  				else        for (var i=0;i<len;++i) p[d]=a[i], dive(d+1);
  				p.pop();
  			}
  			dive(0);
  		}

  		allCombinations([checkedItemsObj[0],checkedItemsObj[1],checkedItemsObj[2]], function(filter1,filter2,filter3){
  			var option = filter1+''+filter2+''+filter3;
  			option = option.replace(/none/g, "");
  			filter += option+', ';
  		});

  		filter = filter.slice(0,-2);
  		query = $(filter);
  		var nrOfFilterChecked = $('.sblf_tabs .sblf_filtercheck:checked').length;
  		if(nrOfFilterChecked==0){
  			query = $('.sbl_boardslist .sblblboard_item');
  		}
  		query.each(function(){
  			var t = $(this);
  			var img = t.find('.sblbl_boardimg img');
  			var src = img.attr('data-imgsrc');
  			img.attr('src', src);
  		});
  		query.addClass('sblblbi_visible');
  	}
  	$(function(){
  		$(document).on('change', '.sblf_tabs .sblf_filtercheck', function(){
  			filterBoards();
  		});
  	});


  	var bmp_loaded = 0;
  	function boardModelPage_isLoaded(loaded){
  		bmp_loaded++;;
  		if(bmp_loaded==4){
  			$('.sblf_filtercheck:first').trigger('change');
  		}
  	}


  	function toFeet(n) {
  		return Math.floor(n / 12) + "'" + (n % 12) + '"';
  	}

  	function toInches(n){

  		return Math.ceil( n * .039 );

  	}

/*

/surfboards
gets the boards? yes - where: /surfboards

*/
function service_SurfboardModelsPage(){

    //throw new Error('died before loading boards');

	//alert('service_SurfboardModelsPage');

	$.ajax({
		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log(data);

		var loops = 0;

		var boards_html = '<!--board content goes here-->';

		boardModelList = data;
		for(var key in data) {

			// FALTA VERIFICAR SE É NEW
			var id_surfboardmodel = data[key].id_surfboardmodel;
			var model = data[key].surfboardmodel;
			var price = data[key].min_price;
			var symbol = data[key].currency.symbol;
			var iso = data[key].currency.iso;
			var img = data[key].img_303;
			var waveSize = 'ws_'+data[key].wavesize.min;
			var boardType = 'bt_'+data[key].id_surfboardmodeltype;
			var skillLevelObj = data[key].skilllevel;
			var skillLevel = '';
			for(var key in skillLevelObj) {
				skillLevel += 'sl_'+key+' ';
			}

            //if start, include row
            //if( loops == 0 ) $('.sbl_boardslist').append('row<div class="row">');

            if( loops == 0 ) boards_html += '<div class="row">';

            //browsers do not accept unclosed elements, so we must build all the html,
            //and on the end, append it..
            /*
			$('.sbl_boardslist').append('																	\
				<div class="col-sm-4 col-xs-12 sblblboard_item '+waveSize+' '+boardType+' '+skillLevel+'">		\
					<div class="sblbl_board">																	\
						<a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">																			\
							<div class="sblbl_board_top">														\
								<div href="#" class="btn btn-warning">New</div>									\
							</div>																				\
							<div class="sblbl_boardimg">														\
								<img src="" class="img-responsive" data-imgsrc="'+img+'">						\
							</div>																				\
							<div class="board_shadow">															\
								<img src="/images/boardswidget_shadow.png">										\
							</div>																				\
							<div class="board_info">															\
								<span class="board_name">'+model+'</span>										\
								<span class="board_price">'+symbol+''+price+' '+iso+'</span>						\
							</div>																				\
						</a>																					\
					</div>																						\
				</div>																							\
			');
			*/

            //show a default image if board does not exist - the designer must make one, the one bellow is no good
            //if( img == '' ) img = 'http://images.shaperbuddy.com.s3-website-us-east-1.amazonaws.com/-1/img/boardlist_avatar.png';

            // extra classes are for the filters
            boards_html += '<div class="col-sm-4 col-xs-12 sblblboard_item '+waveSize+' '+boardType+' '+skillLevel+'">		\
            <div class="sblbl_board">																	\
            <a href="/boards/detail.php?id='+id_surfboardmodel+'&/'+model.replace(' ','-').toLowerCase()+'">																			\
            <div class="sblbl_board_top">														\
            <div href="#" class="btn btn-warning">New</div>									\
            </div>																				\
            <div class="sblbl_boardimg">														\
            <img src="" class="img-responsive" data-imgsrc="'+img+'">						\
            </div>																				\
            <div class="board_shadow">															\
            <img src="/images/boardswidget_shadow.png">										\
            </div>																				\
            <div class="board_info">															\
            <span class="board_name">'+model+'</span>										\
            <span class="board_price">'+symbol+''+price+' '+iso+'</span>						\
            </div>																				\
            </a>																					\
            </div>\
            </div>';

            //PBS: count loops to insert a new row..
            loops++;

            if( loops == 3 ){

                //if( loop == 0 )
                //$('.sbl_boardslist').append('end row</div>start row<div class="row">');

                boards_html += '</div><div class="row">';

                //reset loop counter
                loops = 0;

              }

              //console.log(loops);

        }//end for board data

        //close row
        boards_html += '</div>';

        $('.sbl_boardslist').append(boards_html);
        //$('#surfboards-placeholder').append(boards_html);

        // what happens here..?
        boardModelPage_isLoaded('board_list');
      });
}


/* /surfboards */
function service_SurfboardModelsPage_filter(){
	$('.sblf_tabs .tab-pane').empty();
	$.ajax({
		url: sUrl+'/api/v1/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			var waveSize = data[key].wavesize.min;
			var waveSizeMinMax = data[key].wavesize;
			if($('.sblffc_wavesize_'+waveSize).length < 1){
				$('#sblf_wavesize').append('																														\
					<label>																																			\
					<input class="sblf_filtercheck sblffc_wavesize_'+waveSize+'" type="checkbox" name="" value="" data-filtervalue="ws_'+waveSizeMinMax.min+'">	\
					'+waveSizeMinMax.min+' - '+waveSizeMinMax.max+' Ft 																							\
					</label>																																		\
					');
			}
		}
		boardModelPage_isLoaded('filter_wavesize');
	});


	$.ajax({
		url: sUrl+'/api/v1/surboardmodeltypes?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			$('#sblf_boardtype').append('																			\
				<label>																								\
				<input class="sblf_filtercheck" type="checkbox" name="" value="" data-filtervalue="bt_'+key+'">	\
				'+data[key]+' 																					\
				</label>																							\
				');
		}
		boardModelPage_isLoaded('filter_boardtype');
	});


	$.ajax({
		url: sUrl+'/api/v1/skilllevels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			$('#sblf_skilllevel').append('																			\
				<label>																								\
				<input class="sblf_filtercheck" type="checkbox" name="" value="" data-filtervalue="sl_'+key+'">	\
				'+data[key]+' 																					\
				</label>																							\
				');
		}
		boardModelPage_isLoaded('filter_skilllevel');
	});
}









var locations = new Array();

function service_Dealers(){
	var container = $('.dealers_list_inner');
	container.empty();
	$.ajax({
		url: sUrl+'/api/v1/dealers?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var loadedCountrys = new Array();
		var loadedStates = new Array();

		for(var key in data) {
			var t = data[key];
			var country = t.country;
			var countryId = t.id_country
			var state = t.state;
			var stateId = t.id_state;
			var name = t.name;
			var address = t.address;
			var phone = t.phone;
			var email = t.email;
			var lat = t.gpslat;
			var lng = t.gpslong;

			if( lat != '' ){

				var location = [];

				location['name']       = name;
				location['lat']        = lat;
				location['lng']        = lng;
				location['address']    = address;
				location['phone']      = phone;
				location['email']      = email;
				location['url']        = t.url;

				locations.push( location );

			}

			var isCountryLoaded = (loadedCountrys.indexOf(country)>-1);
			var isStateLoaded = (loadedStates.indexOf(state)>-1);
			// BUILD COUNTRY
			if(!isCountryLoaded){
				loadedCountrys.push(country);
				container.append('									\
					<div id="ct_'+countryId+'" class="dl_country country_'+countryId+'">	\
					<p class="dl_countrytitle">					\
					<span>'+country+'</span>				\
					</p>										\
					<div class="container"></div>				\
					</div>											\
					');
				$('.dealers_filter .df_country').append('<option value="'+countryId+'">'+country+'</option>');
			}
			// BUILD STATE
			if(state!= ''){
				if(!isStateLoaded){
					loadedStates.push(state);
					container.find('.country_'+countryId+' .container').append('	\
						<div class="row dl_areatitle">								\
						<div class="col-xs-12">'+state+'</div>					\
						</div>														\
						<div class="row state_'+stateId+'"></div>					\
						');
				}
			}
			//BUILD SHOPS
			var shopTarget;
			if(state!= ''){
				shopTarget = container.find('.country_'+countryId+' .container .state_'+stateId+'');
			} else {
				shopTarget = container.find('.country_'+countryId+' .container');
			}
			shopTarget.append('																							\
				<div class="col-sm-4 dl_item">																			\
				<h5>'+name+'</h5>																					\
				<p class="dli_address">'+address+'</p>																\
				<p class="dli_phone">																				\
				<label>Phone:&nbsp;</label>'+phone+'															\
				</p>																								\
				<p class="dli_email">																				\
				<label>Email:&nbsp;</label>'+email+'															\
				</p>																								\
				<a href="#" data-lat="'+lat+'" data-lng="'+lng+'" class="dli_viewonmaps" data-toggle="modal" data-target="#modal_viewonmaps">View on Google Maps</a>	\
				</div>																									\
				');
			if(phone==''){
				$('.dl_item:last .dli_phone').remove();
			}
			if(email==''){
				$('.dl_item:last .dli_email').remove();
			}
			if(lat==''){
				$('.dl_item:last .dli_viewonmaps').remove();
			}
		}

		setListItemHeight($('.dl_item'));
		setMarker(locations);

		$(window).trigger('scroll');
	});
}










function service_TeamList(){
	var container = $('.team_list .row');
	container.empty();
	$.ajax({
		url: sUrl+'/api/v1/team?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		for(var key in data) {
			var image = data[key].photothumb;
			var country = data[key].country;
			var name = data[key].name;
			var id = data[key].id_team;
			container.append('															\
				<div class="col-sm-4">													\
				<div class="tl_item">												\
				<a href="/team/detail.php?id='+id+'&/'+name.replace(' ','-').toLowerCase()+'">							\
				<div class="tli_img">										\
				<img src="'+image+'" class="img-responsive">			\
				</div>														\
				<div class="tli_name">'+name+'</div>						\
				<div class="tli_location">'+country+'</div>					\
				</a>															\
				</div>																\
				</div>																	\
				');
		}
		setListItemHeight($('.tl_item').parent());
	});
}





function service_TeamDetail_images(){
	var teamMemberId = getQueryString('id');
	var teamMemberSliderImgs = $('.teammember_slider .carousel-inner');
	var teamMemberSliderIndicators = $('.teammember_slider .carousel-indicators');
	teamMemberSliderImgs.empty();
	teamMemberSliderIndicators.empty();
	$.ajax({
		url: sUrl+'/api/v1/team/'+teamMemberId+'/images?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var loopI = 0;
		for(var key in data) {
			var img = data[key].url;
			teamMemberSliderImgs.append('<div class="item"><img src="'+img+'" alt="..."></div>');
			teamMemberSliderIndicators.append('<li data-target="#chilli_carousel" data-slide-to="'+loopI+'"></li>');
			loopI++;
		}
		teamMemberSliderImgs.find('.item:first').addClass('active');
		teamMemberSliderIndicators.find('.li:first').addClass('active');
	});
}


function service_TeamDetail_video(){
	var teamMemberId = getQueryString('id');
	$.ajax({
		url: sUrl+'/api/v1/team/'+teamMemberId+'/videos?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log( data );

		for(var key in data) {

			var description = data[key].description;
			var url = data[key].url;
			var videoId;
			var videoSource;
			var videoUrl = url;
			var isYoutube = videoUrl.indexOf('youtu') > -1;

			if(isYoutube){
				videoId = youtube_parser(videoUrl);
				videoSource = 'youtube';
			} else {
				var vimeoId = videoUrl.split('/');
				videoId = vimeoId[vimeoId.length - 1];
				videoSource = 'vimeo';
				videoUrl = 'https://player.vimeo.com/video/'+videoId;
			}

			$('.videos_carousel .carousel-inner .active .row').append('							\
				<div class="col-sm-4 vc_item_wrapper">											\
				<a href="'+videoUrl+'" class="vc_item" data-videosource="'+videoSource+'" data-id="'+videoId+'">	\
				<div class="vci_img">													\
				<img src="images/dummies/vc_videothumb.jpg" class="img-responsive">	\
				<div class="playbutton">											\
				<img src="/images/vc_playicon.png">								\
				</div>																\
				</div>																	\
				<div class="vci_title">'+description+'</div>								\
				</a>																		\
				</div>																			\
				');

		}

		setVideoPagination($('.videos_carousel'));
		setVideoProperties();
	});
}

//team details
function service_TeamDetail(){

	var teamMemberId = getQueryString('id');

	$.ajax({
		url: sUrl+'/api/v1/team/'+teamMemberId+'?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var id_team = data.id_team;
		var name = data.name;
		var firstName = name.split(' ')[0];
		var country = data.country;
		var description = data.bio;
		var height = data.height;
		var weight = data.weight;
		var stance = data.stance_txt;
		var quiver = data.surfboardmodels;
		var quiverNrOfBoards = quiver.length;
		var socialNetworks = data.socialnetworks;
		var symbol = data.currency.symbol;
		var iso = data.currency.iso;

		$('.tli_name_main, .breadcrumb .active').html(name);
		$('.tli_location').html(country);
		$('.tli_text').html(description);
		$('.tli_firstname, .insta_widget_wrapper h1 span').html(firstName);
		$('.rider-name').html(firstName+"´s");
		$('.tli_height span').html(height);
		$('.tli_weight span').html(weight);
		$('.tli_stance span').html(stance);


		for(var key in socialNetworks){

			var id_socialnetwork = socialNetworks[key].id_socialnetwork;
			var url = socialNetworks[key].url;

			// facebook
			if(id_socialnetwork=='1'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_fb.png"></a></li>');
			}
			//twitter
			if(id_socialnetwork=='2'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_twitter.png"></a></li>');
			}
			//
			if(id_socialnetwork=='3'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_youtube.png"></a></li>');
			}
			// instagram
			if(id_socialnetwork=='4'){
				$('.tli_follow .getsocial_links ul, .insta_widget_wrapper .getsocial_links ul').append('<li><a href="'+url+'" target="_blank"><img src="/images/social_insta.png"></a></li>');

				//prepare the username, like the designer wants it..
				if( url != null ){

					var url_parts = url.split('/');

					//console.log(url_parts[3]);

					$('.getsocial_subtitle').html( '<a href="'+url+'" target="_blank">@'+url_parts[3]+'</a>' );

				}

				initInstagram_team(socialNetworks[key].memberid);
			}
			// vimeo
			if(id_socialnetwork=='5'){
			}

		}


		var nrOfCols = 12/quiverNrOfBoards;
		if(quiverNrOfBoards>=4){
			nrOfCols = 4;
		}
		var quiverI=0;
		for(var key in quiver) {
			if(quiverI<4){
				var img = quiver[key].images[0].image_74;
				var model = quiver[key].surfboardmodel;
				var price = quiver[key].minprice;

				var height = quiver[key].height;
				var wide = quiver[key].wide;
				var thick = quiver[key].thick;

				var modelDesc = '<p><strong>'+model+'</strong> - '+height+' x '+wide+' x '+thick+' L</p>';

				var surfboard_model = quiver[key].id_surfboardmodel;

				$('.tli_ride').append(modelDesc);

				$('.teammember_quiver .container .row').append('												\
					<div class="col-sm-'+nrOfCols+'">															\
					<div class="sblbl_board">																\
					<a href="/boards/detail.php?id='+surfboard_model+'">																		\
					<div class="sblbl_boardimg">													\
					<img src="'+img+'" class="img-responsive">									\
					</div>																			\
					<div class="board_shadow">														\
					<img src="/images/boardswidget_shadow.png">									\
					</div>																			\
					<div class="board_info">														\
					<span class="board_name">'+model+'</span>									\
					<span class="board_price">'+symbol+''+price+' '+iso+'</span>				\
					</div>																			\
					</a>																				\
					</div>																					\
					</div>																						\
					');
			}
			quiverI++;
		}

		service_homeNews(id_team);

	});
}







function initInstagram_team(id){
	$('.instaimgs_wrapper').empty();
	$.ajax({
		type: "GET",
		dataType: "jsonp",
		cache: false,
		url: 'https://api.instagram.com/v1/users/'+id+'/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075',
        //url: "https://api.instagram.com/v1/tags/pyzelsurfboards/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        success: function(data) {

					//console.log( data );

					var data = data.data;
					var iwIndex = 1;
					$('.instaimgs_wrapper').each(function(){
						var t = $(this);
						var nrOfImgs = t.attr('data-nrofimgs');

						for(var i = 0; i < nrOfImgs; i++){
							var imgThumb = data[i].images.standard_resolution.url;
							var imgUrl = data[i].link;
							t.append('														\
								<div class="it_item">										\
								<a href="'+imgUrl+'" target="_blank">											\
								<img src="'+imgThumb+'" class="img-responsive" alt="'+data[i].caption.text+'">		\
								</a>													\
								</div>														\
								');
						}
						iwIndex++;
					});

					$('.insta_widget').each(function(){
						var t = $(this);
						startInstaWidget(t);
					});
				}
			});
}









function service_Videos(){

    //console.log( 'yo yo service video in the house!' );

    var teamMemberId = getQueryString('id');

    var videoContainer = $('.videos_carousel .carousel-inner .active .row');

    $.ajax({
    	url: sUrl+'/api/v1/cms/zones/44/objects?lang='+sLang,
    	method: 'GET',
    	context: document.body
    }).done(function(data) {

    	//console.log( data );

    	for(var key in data) {
    		var url = data[key].hpurlvideo;
    		var posted = data[key].dt_publication.en;
    		var videoId;
    		var videoSource;
    		var videoUrl = url;
    		var isYoutube = videoUrl.indexOf('youtu') > -1;

    		if(isYoutube){
    			videoId = youtube_parser(videoUrl);
    			videoSource = 'youtube';
    		} else {
    			var vimeoId = videoUrl.split('/');
    			videoId = vimeoId[vimeoId.length - 1];
    			videoSource = 'vimeo';
    			videoUrl = 'https://player.vimeo.com/video/'+videoId;
    		}

    		videoContainer.append('																						\
    			<div class="col-sm-4 vc_item_wrapper">																	\
    			<a href="'+videoUrl+'" class="vc_item" data-videosource="'+videoSource+'" data-id="'+videoId+'">	\
    			<div class="vci_img">																			\
    			<img src="" class="img-responsive">															\
    			<div class="playbutton">																	\
    			<img src="/images/vc_playicon.png">														\
    			</div>																						\
    			</div>																							\
    			<div class="vci_title">'+data[key].hptitle+'</div>																	\
    			<div class="vci_addinfo">Posted on: '+posted+'</div>											\
    			</a>																								\
    			</div>																									\
    			');
    	}

    	setVideoPagination($('.videos_carousel'));
    	setVideoProperties();
    });
  }




// ---------------------------- PRODUCTS LIST --------------------------//

// shop/boards/
//TO-DO: we need to get boards per model.. DONE
// TO-DO: get boards by length, like on JR

function service_productBoardsList(qString){
	var queryLang = "";
	if( sLang!=undefined ){
		queryLang = "&lang="+sLang;
	} 
	var url;
	
	if(qString==undefined){
		url = sUrl+'/api/v1/shop/surfboards'+queryLang;
	} else {
		url = sUrl+'/api/v1/shop/surfboards?'+qString+queryLang;
	}

	//alert(url);

	var boardListContainer = $('.shopitems_list');
	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		boardListContainer.empty();

		var total_surfboards = 0;

		//for loop
		for(var key in data) {

			total_surfboards++;

			var currency = data[key].currency;
			var id = data[key].id_surfboard;
			var img = data[key].img.deck;
			var model = data[key].surfboardmodel;
			var length_inches = data[key].length_inches;
			var width_inches = data[key].width_inches;
			var thickness = data[key].thickness;
			var thickness_inches = data[key].thickness_inches;
			var volume = data[key].volume;
			if(volume!=''){
				volume = ' = '+volume+' L ';
			}
	           /* ===================================================== *
                 * 	Define se a prancha é usada, nova, team e etc...
                 * ===================================================== */
                 var boardstate = data[key].stocktype;

                 var finsystem = data[key].finsystem;
                 var fin_no = data[key].fin_no;
                 var price = data[key].price;

                 if(img == ''){
                 	//img = 'http://images.shaperbuddy.com.s3-website-us-east-1.amazonaws.com/-1/img/boardlist_avatar.png';
                 	img = "/images/boardlist_avatar.png";
                 }

                 boardListContainer.append('																																					\
                 	<div class="col-sm-4 col-xs-12">																																		\
                 	<div class="surfboards-list shopitem">																																				\
                 	<a href="/?page=shopsurfboarddetail&id='+id+'">																													\
                 	<div class="si_img">																																		\
                 	<img class="img-responsive lazy" src="/images/boardlist_avatar.png" data-original="'+img+'">																												\
                 	</div>																																						\
                 	<div class="shponlc_prodinfo">																																\
                 	<div class="shponlc_prodinfo_inner">																													\
                 	<p class="shponlcpi_prodname">'+model+'</p>																											\
                 	<p class="shponlcpi_prodprice"><span class="currency-symbol"></span>'+price+' <span class="currency-iso">'+currency.iso+'</span></p>																		\
                 	<p class="shponlcpi_proddetails">'+length_inches+' x '+width_inches+' x '+thickness_inches+' '+volume+'<br>'+finsystem+' Fin System x '+fin_no+'</p>		\
                 	<p class="shponlcpi_proddetails proddetail_state">'+boardstate+'</p>\
                 	</div>																																					\
                 	</div>																																						\
                 	</a>																																							\
                 	</div>																																								\
                 	</div>																																									\
                 	');

		}//end for?

		//console.log( total_surfboards );

		$('.slfh_results').text( total_surfboards );

		/*
		var nrOfItemsInList = $('.shopitems_list > div').length;
		if(nrOfItemsInList>5){
			$('.shopitems_list > div:eq(4)').after('													\
				<div class="col-sm-4 col-xs-12 shopitem_alternative">									\
					<div class="shopitem">																\
						<a href="/custom-order">																	\
							<div class="si_img">														\
								<img src="/images/custom-order.jpg" class="img-responsive">	\
							</div>																		\
							<div class="si_overtext">													\
								<div class="siot_text">Custom Board Order</div>							\
								<div class="btn_viewall">Start Now</div>								\
							</div>																		\
						</a>																			\
					</div>																				\
				</div>																					\
			');
		} else {
			$('.shopitems_list').append('																\
				<div class="col-sm-4 col-xs-12 shopitem_alternative">									\
					<div class="shopitem">																\
						<a href="#">																	\
							<div class="si_img">														\
								<img src="images/shoplistimg_alternetive1.jpg" class="img-responsive">	\
							</div>																		\
							<div class="si_overtext">													\
								<div class="siot_text">Custom Board Order</div>							\
								<div class="btn_viewall">Start Now</div>								\
							</div>																		\
						</a>																			\
					</div>																				\
				</div>																					\
			');
		}
		*/

		//lazy load images only when doc is ready
		$('document').ready(function(){
			$("img.lazy").lazyload({
				effect : "fadeIn"
			});
		})

		//setListItemHeight($('.shopitem').parent());

		//show no results
		if(data.length==0){
			$('.shopitems_list_noresult').show();
			$('.shopitem_alternative').hide();
		} else {
			$('.shopitems_list_noresult').hide();
			$('.shopitem_alternative').show();
		}

	});

}





//function service_productAccessoriesList(qString){
// refactoring this
function products_list(section, qString){

    	//console.log('yo yo service_productAccessoriesList');
    	var shopdetail = "accessoriesdetail";
	if( section=="accessories" ){
		//accessories
		shopdetail = "accessoriesdetail";
	}else if( section=="apparel" ){
		//clothing
		shopdetail = "appareldetail";
	}else if( section=="softgoods" ){
		//soft goods
		shopdetail = "softgoodsdetail";
	}

    var url;
    if(qString==undefined){
    	url = sUrl+'/api/v1/shop/'+section+'?lang='+sLang;
    } else {
    	url = sUrl+'/api/v1/shop/'+section+'?'+qString+'&lang='+sLang;
    }

	//var boardListContainer = $('.shopitems_list');

	var products_placeholder =  $('#products-placeholder');

	var total_products = 0;

	var html = '';

	products_placeholder.empty();

	var loops = 0;

	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//boardListContainer.empty();

        // start new row
        html = '<div class="row">';

        for(var key in data){

        	loops++;
        	total_products++;

            //console.log( loops );

            var brand = data[key].brand;
            var id_product = data[key].id_product;
            var id_brand = data[key].id_brand;
            var name = data[key].name;
            var currency = data[key].currency;
            var minprice = data[key].minprice;
            var colors = data[key].variant_colors;
            var nrOfColors = colors.length;
            var tabContent = '';
            var tabNavContent = '';
            if(nrOfColors==0){
            	var name = data[key].name;
            	var minprice = data[key].minprice;
            	var mainimg = data[key].mainimg;
            	if( mainimg=="" ){
                	mainimg = "/images/pyzel_noimage.svg";
                }
            	tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img class="img-responsive lazy" src="/images/loading_pyzel.gif" data-original="'+mainimg+'" ></div>';
            	tabNavContent = '';
            } else {
            	for(var key2 in colors){
				// this is not supposed to be part of the name..
                    //var name = colors[key2].name;
                    var hexcolor = colors[key2].hexcolor;
                    var img = colors[key2].img;
                    if( img=="" ){
                    		img = "/images/pyzel_noimage.svg";
                    }
                    if(key2==0){
	                    	var firstActive = 'active in';
	                    	var firstLinkActive = 'active';
	                    	tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img class="img-responsive lazy" src="/images/loading_pyzel.gif" data-original="'+img+'" ></div>';
	                    	tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+colors[key2].name+'">'+key2+'</div></li>';
                    } else {
	                    	var firstActive = '';
	                    	var firstLinkActive = '';
	                    	tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img class="img-responsive lazy" src="'+img+'" data-original="" ></div>';
	                    	tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+colors[key2].name+'">'+key2+'</div></li>';
                    }
                    //tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img class="img-responsive lazy" src="/images/loading_pyzel.gif" data-original="'+img+'" ></div>';
                    //tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+colors[key2].name+'">'+key2+'</div></li>';
                  }
                }

            //console.log( 'name before: '+name );
            name = name.replace(brand, '');
            //console.log( 'name after:' +name );

            //name = 'here be name';
            html +=
            '<div class="col-sm-4 col-xs-12">\
            <div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">\
            <a href="/index.php?page='+shopdetail+'&id='+id_product+'&shop='+section+'" data-url="/index.php?page='+shopdetail+'&id='+id_product+'&shop='+section+'">\
            <div class="tab-content">'+tabContent+'</div>\
            <div class="shponlc_prodinfo_inner">\
            <p class="shponlcpi_prodname">'+brand+' '+name+'</p>\
            <p class="shponlcpi_proddetails"></p>\
            <p class="shponlcpi_prodprice"><span>'+currency.symbol+'</span>'+minprice+'<span class="currency"> '+currency.iso+'</span></p>\
            </div>\
            <div class="variants_nav">\
            <ul>'+tabNavContent+'</ul>\
            </div>\
            </a>\
            </div>\
            </div>';


            // close previous row and open new
            if( loops == 3 ){

            	html += '</div><div class="row">';

            	loops = 0;

            }


		} // end for

        // close open row
        html += '</div>';

        //console.log('appending: '+html);

        products_placeholder.html( html );

        // total results on side bar
        $('.slfh_results').text( total_products );

        // and this does what?
        // removes the placeholder div when no text exists..
        $('.shponlcpi_proddetails').each(function(){
        	var t = $(this);
        	var text = t.text();
        	if(text==''){
        		t.remove();
        	}
        });

		//setListItemHeight($('.shopitem').parent());

		$("img.lazy").lazyload({
			effect: "fadeIn"
		});
	});

}

// PBS: hide / show filters according to device width..
$( document ).ready( function(){

	$(window).on("load resize",function(e){

		if($(document).width() < 767 ) {

            //console.log('width is smaller than 767, so collapsing');
            $( $('.slfg_toggle').attr('href') ).collapse('hide');

          }else{

            //console.log('width is bigger than 767, so expanding');
            $( $('.slfg_toggle').attr('href') ).collapse('show');

          }

        });

})



// this could be the same function as accessories just change the end point..
// done.
function service_productApparelList(qString){

	if(qString==undefined){
		url = sUrl+'/api/v1/shop/apparel?lang='+sLang;
	} else {
		url = sUrl+'/api/v1/shop/apparel?'+qString+'&lang='+sLang;
		console.log( sUrl );
	}

	var boardListContainer = $('.shopitems_list');
	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		boardListContainer.empty();

		for(var key in data){
			var id_product = data[key].id_product;
			var id_brand = data[key].id_brand;

			var mainName = data[key].name;
			var currency = data[key].currency;
			var minprice = data[key].minprice;


			var colors = data[key].variant_colors;
			var nrOfColors = colors.length;
			var tabContent = '';
			var tabNavContent = '';

			if(nrOfColors==0){
				var name = data[key].name;
				var minprice = data[key].minprice;
				var mainimg = data[key].mainimg;
				tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img src="'+mainimg+'" class="img-responsive"></div>';
				tabNavContent = '';
			} else {
				for(var key2 in colors){
					var name = colors[key2].name;
					var hexcolor = colors[key2].hexcolor;
					var img = colors[key2].img;


					if(key2==0){
						var firstActive = 'active in';
						var firstLinkActive = 'active';
					} else {
						var firstActive = '';
						var firstLinkActive = '';
					}
					tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img src="'+img+'" class="img-responsive"></div>';
					tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+name+'">'+key2+'</div></li>';
				}
			}



			boardListContainer.append('																																					\
				<div class="col-sm-4 col-xs-12">																																		\
				<div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">																				\
				<a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel">						\
				<div class="si_img">																																		\
				<div class="tab-content">'+tabContent+'</div>																											\
				</div>																																						\
				<div class="shponlc_prodinfo">																																\
				<div class="shponlc_prodinfo_inner">																													\
				<p class="shponlcpi_prodname">'+mainName+'</p>																										\
				<p class="shponlcpi_proddetails"></p>																												\
				<p class="shponlcpi_prodprice"><span>'+currency.symbol+'</span>'+minprice+'<span class="currency"> '+currency.iso+'</span></p>						\
				</div>																																					\
				<div class="variants_nav">																																\
				<ul>'+tabNavContent+'</ul>																															\
				</div>																																					\
				</div>																																						\
				</a>																																							\
				</div>																																								\
				</div>																																									\
				');
		}


		$('.shponlcpi_proddetails').each(function(){
			var t = $(this);
			var text = t.text();
			if(text==''){
				t.remove();
			}
		});


		setListItemHeight($('.shopitem').parent());
	});
}

// -------------------------- end PRODUCTS LIST ------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//

// /shop/surfboards and others..
// mainly it builds the filters, then call products of X category..

function service_productBoardsListFilter(shop){	

	var url;
	if( shop == 'boards' || shop == 'garage' ){
		url = sUrl+'/api/v1/shop/surfboards/filters?lang='+sLang;
	} else if(shop=='apparel'){
		url = sUrl+'/api/v1/shop/apparel/filters?lang='+sLang;
	} else if(shop=='accessories'){
		url = sUrl+'/api/v1/shop/accessories/filters?lang='+sLang;
	}else if(shop=='softgoods'){
		url = sUrl+'/api/v1/shop/softgoods/filters?lang='+sLang;
	}

	/*else if( shop == 'garage' ){

		url = sUrl+'/api/v1/shop/surfboards/filters?id_used_state=1&lang='+sLang;

	}*/
	
	$.ajax({
		url: url,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var filterListContainer = $('.slf_filterlist');
		var rangeValueItems = new Array('6', '7', '11');
		var flcIndex = 1;

		for(var key in data){
			
			// disable price filter for now
			if( data[key].id == 11 ){
				
				continue;

			} 

			var id = data[key].id;
			var filterName = data[key].name;
			var filterVar = data[key].var;
			var filterItems = data[key].item;
			var itemsufix = data[key].itemsufix;
			
			if(itemsufix==undefined){
			
				itemsufix = '';

			}

			filterListContainer.append('																							\
				<div class="slf_group">																								\
				<a class="slfg_toggle" role="button" data-toggle="collapse" href="#collapse'+flcIndex+'" aria-expanded="true">	\
				<div class="slfg_toggle_inner">'+filterName+'</div>															\
				</a>																											\
				<div class="slfg_items collapse in" id="collapse'+flcIndex+'">													\
				<div class="slfg_items_inner" data-filterdataname=""></div>													\
				</div>																											\
				</div>																												\
				');

			var isRangeItem = rangeValueItems.indexOf(id);

            //console.log( 'isRangeItem: '+isRangeItem );

            if(isRangeItem>-1){

            	var rangeMin = filterItems.min;
            	var rangeMax = filterItems.max;
            	filterVar = filterVar.split(',');
            	$('.slf_group:last').find('.slfg_items_inner').append('														\
            		<label>																									\
            		<div class="row filterrange_preview">																\
            		<div class="col-xs-4 frp_col1">																	\
            		<input class="filterdata fr_min" type="text" name="'+filterVar[0]+'" value="" readonly>		\
            		<input class="fr_display fr_min_display" id="fr-min-display-'+id+'" value="" readonly>									\
            		</div>																							\
            		<div class="col-xs-4 frp_col2">TO</div>															\
            		<div class="col-xs-4 frp_col3">																	\
            		<input class="filterdata fr_max" type="text" name="'+filterVar[1]+'" value="" readonly>		\
            		<input class="fr_display fr_max_display" id="fr-max-display-'+id+'" value="" readonly>									\
            		</div>																							\
            		</div>																								\
            		<div class="filterrange_'+id+' filterrange" data-min="'+rangeMin+'" data-max="'+rangeMax+'"></div>	\
            		</label>																								\
            		');

            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filtertype', 'range');
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname', filterVar);
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname_min', filterVar[0]);
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname_max', filterVar[1]);
            	startBoardSizeSlider('filterrange_'+id+'', rangeMin, rangeMax);

            } else {

            	if( filterName=='By Sport' ){
            		$.each( filterItems, function( key, value ){

            			$('.slf_group:last').find('.slfg_items_inner').append('														\
            				<label data-itemsufix="'+itemsufix+'">																									\
            				<input class="sblf_filtercheck filterdata" type="radio" name="'+filterVar+'" value="'+key+'">	\
            				'+filterItems[key]+' 																				\
            				</label>																								\
            				');

            		})
            	}else{

            		$.each( filterItems, function( key, value ){

            			$('.slf_group:last').find('.slfg_items_inner').append('														\
            				<label data-itemsufix="'+itemsufix+'">																									\
            				<input class="sblf_filtercheck filterdata" type="checkbox" name="'+filterVar+'" value="'+key+'">	\
            				'+filterItems[key]+' 																				\
            				</label>																								\
            				');

            		})
            	}    

            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filtertype', 'list');
            	$('.slf_group:last').find('.slfg_items_inner').attr('data-filterdataname', filterVar);

            }

            flcIndex++;
          }

          $('.slfg_items_inner input[name=id_finsystem_nr]').parent().append(' - Fins');


          if(isMobile){
          	$('.slf_filterlist .slfg_toggle').trigger('click');
          }

          //try to mark the id_producttag of the board as selected if in url query string
		var id_producttag = getQueryString('id_producttag');
		var id_producttag_split = id_producttag.split(",");

		if( id_producttag != '' ){
			$('.filterdata[name="id_producttag"]').prop('checked', false);

			for (key in id_producttag_split){
	        		if( id_producttag_split[key] != '' ){
	        			$('.filterdata[name="id_producttag"][value="'+id_producttag_split[key]+'"]').prop('checked', true);
	        		}	
	        	}
		//	$('.filterdata[name=id_producttag][value="'+id_producttag+'"]').attr('checked',true)
		}

		//try to mark the model of the board as selected if in url query string
		var board_model = getQueryString('model');

		if( board_model != '' ){
			$('.filterdata[name=id_surfboardmodel][value="'+board_model+'"]').attr('checked',true)
		}

		//try to mark the brand of the board as selected if in url query string
		var _id_brand = getQueryString('id_brand');

		if( _id_brand != '' ){
			$('.filterdata[name=id_brand][value="'+_id_brand+'"]').attr('checked',true)
		}

		//try to mark the model of the board as selected if in url query string
		var board_sport = getQueryString('sport');

		if( board_sport != '' ){
			$('.filterdata[name=id_sport][value="'+board_sport+'"]').attr('checked',true)
		}		

        //PBS: try to mark the technology of the board aas selected if in url query string
        var technology = getQueryString('technology');

        if( technology != '' ){
        	$('.filterdata[value="'+technology+'"]').attr('checked',true)
        }

        // usedstate
        var id_usedstate = getQueryString('id_usedstate');
        var id_usedstate_split = id_usedstate.split(",");

        if( id_usedstate != "" ){
        	$('.filterdata[name="id_usedstate"]').prop('checked', false);

        	for (key in id_usedstate_split){
        		if( id_usedstate_split[key] != '' ){
        			$('.filterdata[name="id_usedstate"][value="'+id_usedstate_split[key]+'"]').prop('checked', true);
        		}	
        	}
        }else{
	  	// 02.08.2016: set as default new surfboards..
	  	$('[name="id_usedstate"]:input[value="0"]').prop( 'checked', true );
	  }

        // set length
        var length = getQueryString('length');

        if( length != '' ){

        	var length_inches = toInches( length );
            //var length_feet = toFeet( length );

            startBoardSizeSlider( "filterrange_6", window.rangeMin, window.rangeMax, length_inches, length_inches );
            //startBoardSizeSlider( "filterrange_6", 50, 50 );

          }

        	//this sets the filter, does stuff, and then call all the boards..
		//defined at shop_boards.js
		getStandarDimensionsFilter();

		//service_setFilterProperties();

	});


}


// --------------------------  PRODUCTS DETAIL -------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//
// ---------------------------- ------------- --------------------------//

function setProductImgs(imgArray){

	// --- IMG VIEWR
	var imgs = imgArray;
	$('.sld_imgviewr .tab-content').empty();
	$('.sld_imgviewr .sld_imgviewr_thumbswrapper').empty();
	var imgLoopI = 1;
	var imgSize = $("#carousel-surfboard-detail .item.active").length;
	$("#carousel-surfboard-detail .carousel-indicators li").remove();
	for(var key in imgs){
		//var imgUrl = imgs[key].url;
		var imgUrl = imgs[key].img_dynamic;
		if( imgLoopI == 1 && imgSize == 0 ){
			// add imagem no carousel (active)
			$("#carousel-surfboard-detail .carousel-inner").html('\
					<div class="item active">\
				      	<img src="'+imgUrl+'" alt="Image" class="img-responsive image-larger-100">\
			      	</div>');
			// add indicator no carousel (active)
			$("#carousel-surfboard-detail .carousel-indicators").append('<li data-target="#carousel-surfboard-detail" data-slide-to="'+imgLoopI+'" class="active"></li>');
		}else{
			// add imagem no carousel
			$("#carousel-surfboard-detail .carousel-inner").append('\
					<div class="item">\
				      	<img src="'+imgUrl+'" alt="Image" class="img-responsive image-larger-100">\
			      	</div>');
			// add indicator no carousel
			$("#carousel-surfboard-detail .carousel-indicators").append('<li data-target="#carousel-surfboard-detail" data-slide-to="'+imgLoopI+'" class=""></li>');
		}
		imgLoopI++;
	}

	if( $(".sld_imgviewr .item").length==1 ){
		$(".sld_imgviewr .carousel-control").hide();
		$(".sld_imgviewr .carousel-indicators").hide();
	}

	$('.sld_imgviewr .tab-content .tab-pane:first').addClass('active');
	$('.sld_imgviewr .tab-content .tab-pane:first').addClass('in');

/*
	var allThumbs = $('.sld_imgviewr_thumbswrapper img');
	var nrOfItems = allThumbs.length;
	var loadedImgs = 0;
	allThumbs.one("load", function() {
		loadedImgs++;
		if(loadedImgs===nrOfItems){
			verticalCenterThumbs();
		}
	}).each(function() {
		if(this.complete) $(this).load();
	});
*/

	$(window).resize(function(){
		verticalCenterThumbs();
	});

	function verticalCenterThumbs(){
		var imgViewrHeight = $('.sld_imgviewr').height();
		var imgViewrthumbswrapper = $('.sld_imgviewr_thumbswrapper').height();
		var thumbsCenter = (imgViewrHeight/2)-(imgViewrthumbswrapper/2);
		$('.sld_imgviewr_thumbswrapper').stop().animate({ 'margin-top': thumbsCenter });
	}
	// --- end IMG VIEWR

}


function setOtherProducts(otherproducts) {

	if ( otherproducts == '' || otherproducts == undefined  ){
		$('.youmaybeinterested').empty();
	}
	
	//console.log( otherproducts );

	$('.ymbi_prodlist > .container > .row').empty();
	for(var key in otherproducts){
		var id = otherproducts[key].id;
		var id_producttypeOther = otherproducts[key].id_producttype;
		var id_variant = otherproducts[key].id_variant;
		var id_type = otherproducts[key].id_type;
		var name = otherproducts[key].name;
		var price = otherproducts[key].price;
		var img = otherproducts[key].img;
		var product_type = otherproducts[key].producttype.toLowerCase();

		//trick..
		if( product_type == 'surfboard' ) product_type = 'surfboards';

		//must get category of this product..
		$('.ymbi_prodlist > .container > .row').append('															\
			<div class="col-sm-2 col-xs-6">																			\
			<div class="shopitem">																				\
			<a href="/shop/'+product_type+'/detail.php?id='+id+'&shop='+product_type+'">																						\
			<div class="si_img">																		\
			<img src="'+img+'" class="img-responsive">												\
			</div>																						\
			<div class="shponlc_prodinfo">																\
			<div class="shponlc_prodinfo_inner">													\
			<p class="shponlcpi_prodname">'+name+'</p>											\
			<p class="shponlcpi_prodprice">$'+price+' <span class="currency">AUD</span></p>		\
			</div>																					\
			<div href="#" data-prdid="'+id+'" class="btn-addtocart addtocart addtocart_singleqty" data-id_product="'+id+'" data-id_producttype="'+id_producttypeOther+'" data-variant="">Add To Cart</div>		\
			</div>																						\
			</a>																							\
			</div>																								\
			</div>																									\
			');
	}
}

function service_productBoardsList_detail(){

	var boardId = getQueryString('id');
	$.ajax({
		url: sUrl+'/api/v1/shop/surfboards/'+boardId,
		method: 'GET',
		context: document.body
	}).done(function(data) {		

		console.log( 'data' );
		console.log( data );

		//console.log( 'webprice' );
		//console.log( data[0].webprice );

		//console.log( typeof data[0].webprice );

		//console.log( 'new stuff really new. really. really. oh rly?' );

		//console.log( typeof data[0].webprice );

		if( data == '' || ( typeof data[0].webprice !== 'undefined' && data[0].webprice == "" ) ){		
			
			$('#board-description-col').remove();

			var modal = '\
			<div class="modal fade" tabindex="-1" role="dialog" id="error-modal">\
  				<div class="modal-dialog" role="document">\
    				<div class="modal-content">\
      					<div class="modal-header">\
      						<h4 class="modal-title">Error</h4>\
      					</div>\
      					<div class="modal-body text-center">\
      						Selected board is not available at the moment.\
      					</div>\
      					<div class="modal-footer">\
        					<a href="/?page=shopsurfboard" class="btn btn-default">See other boards</a>\
      					</div>\
      				</div>\
      			</div>\
      		</div>';

      		$('body').append( modal );

      		$('#error-modal').modal({
      		
      			backdrop: 'static',
    			keyboard: false,
    			show:	  true

      		});

			throw new Error('Selected board is not available at the moment.');

		}

		var id_surfboard = data[0].id_surfboard;
		var id_producttype = data[0].id_producttype;
				
		var imgs = data[0].img;		

		console.log( imgs );

		// if no product images, do some trick..
		//console.log( 'imgs.length:' );
		//console.log( imgs.length );
		
		if( imgs != '' ){

			// show controls if image exists
			$('#surfboard-carousel-controls').removeClass('hidden');
			console.log('removed hidden class??');

		}else{

			console.log('no images are defined for this board');
			// try to load default images from model

		}
		
		var boardName = data[0].surfboardmodel;
		var boardPrice = data[0].price;
		var currency_iso = data[0].currency.iso;
		var currency_symbol = data[0].currency.symbol;
		var promo = data[0].promo;
		var boardSize = data[0].length_inches;
		var boardWidth = data[0].width_inches;
		var boardThickness = data[0].thickness_inches;
		var boardVolume = data[0].volume;
		var tailShape = data[0].tailname;
		var finSystem = data[0].finsystem +' '+ data[0].finsystemoption +' '+ data[0].fin_no +'fin setup';

		// show link if electralite
		if( data[0].id_surfboardconstructiontype == 818 )
			var construction = '<a href="/?page=technology&id=647&electralite-surfboards">'+data[0].surfboardconstructiontype+'</a>';
		else
			var construction = data[0].surfboardconstructiontype;			

		var glassing = data[0].glassing;
		var condition = data[0].condition;
		var waveSize = data[0].wh_min +' - '+ data[0].wh_max +' '+ data[0].wh_measure;
		// ---
		var skillLevel = data[0].skilllevel;
		var skillLevelString = '';
		for(var key in skillLevel){
			skillLevelString += skillLevel[key]+', ';
		}
		skillLevelString = skillLevelString.slice(0, -2);
		// ---
		var waveType = data[0].wavetype_txt;
		var locationName = data[0].location.name;
		var locationAddress = data[0].location.address;
		var locationCountry = data[0].location.country;
		var locationLat = data[0].location.gpslat;
		var locationLng = data[0].location.gpslong;
		var description = data[0].description;
		var paymentSecurity = data[0].payment_security_txt;
		var shippingText = data[0].shipping_txt;
		var otherproducts = data[0].otherproducts;
	     /* ======================================================= *
           * 	Define se a prancha é usada, nova, team e etc...
           * ======================================================= */
           var boardstate = data[0].stocktype;

           if(id_producttype=='1' || id_producttype=='4'){
           	$('.sldi_addtocart .addproduct_qty').prop('readonly', true).val(1);
           }

           $('.pp_currencysymbol').html(currency_symbol);
           $('.pp_currencyiso').html(currency_iso);
		
		setProductImgs(imgs);

		//alert('ranholas??');

		if( boardName!='' ){
			$('.breadcrumb .active').html(boardName+' '+boardSize);
		}
		
		$('.prod_top').html('ID '+id_surfboard);
		$('.prod_title').html(boardName);
		$('.prod_title_size').html(boardSize);
		$('.pprice_value').html(boardPrice);
		$('.prod_state_title').html(boardstate);

		$('.promo_wrapper').empty();

		for(var key in promo){
			var id = key;
			var text = promo[key];
			if(id!='-1'){
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(/images/icon_'+id+'.jpg);">'+text+'</p>');
			} else {
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(/assets/img/icon_45667.jpg);">'+text+'</p>');
			}
		}
		$('.bd_size').html(boardSize);
		$('.bd_width').html(boardWidth);
		$('.bd_thickness').html(boardThickness);
		if( boardVolume!='' ){
			$('.bd_volume').html(boardVolume+' L');
		}
		$('.bf_tailshape span').html(tailShape);
		$('.bf_finsystem span').html(finSystem);
		$('.bf_construction span').html(construction);
		$('.bf_glassing span').html(glassing);
		$('.bf_condition span').html(condition);
		$('.bf_wavesize span').html(waveSize);
		$('.bf_skilllevel span').html(skillLevelString);
		$('.bf_wavetype span').html(waveType);
		$('.sld_stocklocation strong').html(locationName);
		$('.sld_stocklocation .sldsl_text').html(locationAddress);
		$('.sld_stocklocation .sldsl_text').append('<br>'+locationCountry+'<br><br>');
		$('.sld_stocklocation a').attr('href', 'https://www.google.com/maps/dir/Current+Location/'+locationLat+','+locationLng); //https://www.google.com/maps/dir/Current+Location/'+locationLat+','+locationLng
		$('.sld_description .sldd_text').html(description);
		$('.sld_paymentandsecurity .sldps_text').html(paymentSecurity);
		$('.sld_shipping .sldshipping_text').html(shippingText);

		//$('ol.breadcrumb li.board_name a').attr('href', '/shop/boards/?model='+id_surfboardmodel);

		setOtherProducts(otherproducts);

        //$('.sldi_addtocart .addtocart').attr('data-id_product', id_surfboard);
        //$('.sldi_addtocart .addtocart').attr('data-id_producttype', id_producttype);

        // PBS: work here
        $('#btn-add-to-cart').attr('data-id_product', id_surfboard);
        $('#btn-add-to-cart').attr('data-id_producttype', id_producttype);

        var is_on_cart = $.grep( surfboards_id_on_cart, function( value ){

        	return value == boardId;

        })

        if( is_on_cart.length > 0 ){

        	var el = $("#btn-add-to-cart[data-id_product='" + is_on_cart + "']");

        	var string_addedtocart = "ADDED TO CART";
        	if( sLang=="pt" ) string_addedtocart = "ADICIONADO AO CARRINHO";
        	
        	el.html('<i class="glyphicon glyphicon-ok"></i> '+string_addedtocart);
        	el.addClass('disabled');

        }else if( $("#btn-add-to-cart").hasClass('disabled') ){

        	var el = $("#btn-add-to-cart");

        	el.removeClass('disabled');
        	el.html('<i class="glyphicon glyphicon-shopping-cart"></i> ADD TO CART');

        }

        if(construction==''){
        	$('.bf_construction').hide();
        }
        if(glassing==''){
        	$('.bf_glassing').hide();
        }
        if(condition==''){
        	$('.bf_condition').hide();
        }
      });
}














function service_productAccessories_detail(){

    //console.log('service_productAccessories_detail()');

    var variantsData;
    var id_product;
    var id_producttype;

    $(document).on('click', '.vc_innactive', function(e){
    	e.preventDefault();
    })
    	$(document).on("click", ".variant_container ul li a:not(.vc_innactive)", function(e){
    	e.preventDefault();
    	var t = $(this);
    	var vContainer = t.closest('.variant_container');
    	var id_variant = '';
    	var old_price = '';
    	var price = '';
    	var matchFound_hascomb = false;
    	var matchFound_findcomb = false;
    	vContainer.find('.v_selected').removeClass('v_selected');
    	t.addClass('v_selected');
    	var activeV1 = $('.vc_1 ul li a.v_selected').parent().attr('data-id');
    	var activeV2 = $('.vc_2 ul li a.v_selected').parent().attr('data-id');
    	var activeV3 = $('.vc_3 ul li a.v_selected').parent().attr('data-id');
    	if(activeV1 == undefined){
    		activeV1 = '';
    	}
    	if(activeV2 == undefined){
    		activeV2 = '';
    	}
    	if(activeV3 == undefined){
    		activeV3 = '';
    	}
    	for(var key in variantsData){
    		var variant1 = variantsData[key].variant1;
    		var variant2 = variantsData[key].variant2;
    		var variant3 = variantsData[key].variant3;

    		if(activeV1==variant1 && activeV2==variant2 && activeV3==variant3){
    			id_variant = variantsData[key].id_variant;
    			matchFound_hascomb = true;

    			old_price = variantsData[key].old_price;
    			price = variantsData[key].price;
    			break;
    		}
    	}

    	if(matchFound_hascomb){
    		for(var key in variantsData){
    			var curr_id_variant = variantsData[key].id_variant;
    			if(curr_id_variant == id_variant){
    				var variantImgs = variantsData[key].img;
    				matchFound_findcomb = true;
    				break;
    			}
    		}
    		if( $("#carousel-surfboard-detail .item.active").length>0 ){
    			$("#carousel-surfboard-detail .item").remove();
    		}
    		setProductImgs(variantImgs);
    		$('.pprice_value').html(price);
    		$('.pp_oldprice').html(old_price);
    		if(old_price==''){
    			$('.oldprice_wrapper').hide();
    		} else {
    			$('.oldprice_wrapper').show();
    		}

            /*
			$('.sldi_addtocart .addtocart').attr('data-id_product', id_product);
			$('.sldi_addtocart .addtocart').attr('data-id_producttype', id_producttype);
			$('.sldi_addtocart .addtocart').attr('data-variant', id_variant);
			*/

			$('#btn-add-to-cart').attr('data-id_product', id_product);
			$('#btn-add-to-cart').attr('data-id_producttype', id_producttype);
			$('#btn-add-to-cart').attr('data-variant', id_variant);

		}

		// ---------- FILTER AVAILABLE COMBINATIONS ------------- //
		var variantNr = t.closest('.variant_container').attr('data-variant');
		if(variantNr=='1'){
			var variantAvailableArray = new Array();
			for(var key in variantsData){
				var lVariant1 = variantsData[key].variant1;
				if(lVariant1==activeV1){
					if(variantAvailableArray.indexOf(variantsData[key].variant2)<0){
						variantAvailableArray.push(variantsData[key].variant2);
					}
					if(variantAvailableArray.indexOf(variantsData[key].variant3)<0){
						variantAvailableArray.push(variantsData[key].variant3);
					}
				} else {
					continue;
				}
			}

			$('.vc_2 ul li a').addClass('vc_innactive');
			$('.vc_3 ul li a').addClass('vc_innactive');;
			$('.vc_2 ul li a, .vc_3 ul li a').each(function(){
				var t = $(this);
				var tVariantName = t.parent().attr('data-id');
				var tVariantAvailable = variantAvailableArray.indexOf(tVariantName);
				if(tVariantAvailable>-1){
					t.removeClass('vc_innactive');
				}
			});

			var vc2_isSelectedInnactive = $('.vc_2 ul li a.v_selected.vc_innactive').length;
			var vc3_isSelectedInnactive = $('.vc_3 ul li a.v_selected.vc_innactive').length;

			if(vc2_isSelectedInnactive>0){
				$('.vc_2 ul li a:not(.vc_innactive)').first().trigger('click');
			}
			if(vc3_isSelectedInnactive>0){
				$('.vc_3 ul li a:not(.vc_innactive)').first().trigger('click');
			}
		}
		// -------- end FILTER AVAILABLE COMBINATIONS ----------- //

	});

    var boardId = getQueryString('id');
    var shop = getQueryString('shop');

    $('.bc_shop').text(shop);
    if(shop=='apparel'){
    	$('.bc_shop').attr('href', '/index.php?page=shopappareldetail&lang='+sLang+'' );
    } else {
    	$('.bc_shop').attr('href', '/index.php?page=shopaccessoriesdetail&lang='+sLang+'');
    }

    $.ajax({
    	url: sUrl+'/api/v1/shop/'+shop+'/'+boardId,
    	method: 'GET',
    	context: document.body
    }).done(function(data) {

        //console.log( data[0] );

		if( data == '' ){							

			var modal = '\
			<div class="modal fade" tabindex="-1" role="dialog" id="error-modal">\
  				<div class="modal-dialog" role="document">\
    				<div class="modal-content">\
      					<div class="modal-header">\
      						<h4 class="modal-title">Error</h4>\
      					</div>\
      					<div class="modal-body text-center">\
      						Selected product is not available at the moment.\
      					</div>\
      					<div class="modal-footer">\
        					<a href="javascript:history.go(-1)" class="btn btn-default">See other products</a>\
      					</div>\
      				</div>\
      			</div>\
      		</div>';

      		$('body').append( modal );

      		$('#error-modal').modal({
      		
      			backdrop: 'static',
    			keyboard: false,
    			show:	  true

      		});

			throw new Error('Selected product is not available at the moment.');

		}        

        var brand = data[0].brand;

        var name = data[0].name.replace(brand, '');
        var currency_symbol = data[0].currency.symbol;
        var currency_iso = data[0].currency.iso;
        var description = data[0].description;
        var spec = data[0].spec;
        var paymentSecurity = data[0].payment_security_txt;
        var shippingText = data[0].shipping_txt;
        var promo = data[0].promo;
        var otherproducts = data[0].otherproducts;
        var videos = data[0].videos;

        var variantColorsSize = data[0].variant_colors.length;

        if(variantColorsSize==0){
        	var old_price = data[0].old_price;
        	var price = data[0].minprice;
        	$('.pprice_value').html(price);
        	$('.pp_oldprice').html(old_price);
        	if(old_price==''){
        		$('.oldprice_wrapper').hide();
        	} else {
        		$('.oldprice_wrapper').show();
        	}
        }

        var variantImgs = data[0].variants[0].img;
        setProductImgs(variantImgs);

        var id_product = data[0].id_product;
        var id_producttype = data[0].id_producttype;
        var id_variant = data[0].variants[0].id_variant;

        /*
		$('.sldi_addtocart .addtocart').attr('data-id_product', id_product);
		$('.sldi_addtocart .addtocart').attr('data-id_producttype', id_producttype);
		$('.sldi_addtocart .addtocart').attr('data-variant', id_variant);
		*/

		$('#btn-add-to-cart').attr('data-id_product', id_product);
		$('#btn-add-to-cart').attr('data-id_producttype', id_producttype);
		$('#btn-add-to-cart').attr('data-variant', id_variant);

		$('.breadcrumb .active a').html(name);
		$('.prod_title').html(brand+' '+name);
		$('.pp_currencysymbol').html(currency_symbol);
		$('.pp_currencyiso').html(currency_iso);

		$('.sld_description .sldd_text').html(description);
		$('.sld_description .sldspec_text').html(spec);

		if(description==''){
			$('.sldd_text_wrapper').hide();
		}

		if(spec==''){
			$('.sldspec_text_wrapper').hide();
		}

		$('.sld_paymentandsecurity .sldps_text').html(paymentSecurity);
		$('.sld_shipping .sldshipping_text').html(shippingText);

		for(var key in promo){
			var id = key;
			var text = promo[key];
			if(id!='-1'){
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(images/icon_'+id+'.jpg);">'+text+'</p>');
			} else {
				$('.promo_wrapper').append('<p class="promo_disclaimer" style="background-image: url(/assets/img/icon_45667.jpg);">'+text+'</p>');
			}
		}
		setOtherProducts(otherproducts);

		var videoLoopI = 0;

		for(var key in videos) {
			if(videoLoopI==-1){
				break;
			}
			var url = videos[key];
			var videoId;
			var videoSource;
			var videoHtml;
			var videoUrl = url;
			var isYoutube = videoUrl.indexOf('youtu') > -1;

			if(isYoutube){
				videoId = youtube_parser(videoUrl);
				videoSource = 'youtube';
			} else {
				var vimeoId = videoUrl.split('/');
				videoId = vimeoId[vimeoId.length - 1];
				videoSource = 'vimeo';
				videoUrl = 'https://player.vimeo.com/video/'+videoId;
			}

			if(videoSource=='vimeo'){
				videoHtml = '<iframe src="https://player.vimeo.com/video/'+videoId+'" width="90%" height="281" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
			} else if(videoSource=='youtube'){
				videoHtml = '<iframe width="90%" height="315" src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
			}
			$('.sld_videoviewr').append(videoHtml);

			videoLoopI++;
		}

		variantsData = data[0].variants;

		var variantNames = data[0].variant_names;
		var variantsList = new Array();
		var nrOfVariants;
		var vli = 1;

        //console.log( variantNames );

        // defines the type of variants: size, color..
        for(var key in variantNames){
        	var variantName = variantNames[key].name;
        	var variantId = variantNames[key].id;
        	if(variantName != ''){
        		variantsList.push(variantName);
        		$('.vc_'+vli).addClass('vc_active');
        		$('.vc_'+vli).find('.variant_name').text(variantName);
        		switch(variantId) {
        			case '1':
        			$('.vc_'+vli).addClass('variant_colors_wrapper');
        			break;
        			case '2':
        			$('.vc_'+vli).addClass('variant_size_wrapper');
        			break;
        			default:
        			$('.vc_'+vli).addClass('variant_misc_wrapper');
        		}
        	}
        	vli++;
		}// end for


		nrOfVariants = variantsList.length;


        // what happens here..?
        for(var key in variantsData){

            //console.log( variantsData );

            var variant1 = variantsData[key].variant1;
            var variant1_id_type = variantsData[key].variant1_id_type;
            var variant1_type = variantsData[key].variant1_type;
            var hexcolor = variantsData[key].hexcolor;

            //console.log( hexcolor );

            if(variant1_id_type != ''){
            	var variantExist = $('.vc_1').find('ul li[data-id="'+variant1+'"]').length;
            	if(variantExist == 0){

                    if( variant1_id_type != 2 ) // NOT size - apply background color
                    	$('.vc_1').find('ul').append('<li data-id="'+variant1+'"><a href="#" style="background-color:'+hexcolor+';" >'+variant1+'</a></li>');
                    else // size - DON´T apply background..
                    	$('.vc_1').find('ul').append('<li data-id="'+variant1+'"><a href="#">'+variant1+'</a></li>');
                  }
                }
              }

              for(var key in variantsData){

              	var variant2 = variantsData[key].variant2;
              	var variant2_id_type = variantsData[key].variant2_id_type;
              	var variant2_type = variantsData[key].variant2_type;

              	if(variant2_id_type != ''){
              		var variantExist = $('.vc_2').find('ul li[data-id="'+variant2+'"]').length;
              		if(variantExist == 0){
              			$('.vc_2').find('ul').append('<li data-id="'+variant2+'"><a href="#">'+variant2+'</a></li>');
              		}
              	}
              }

              for(var key in variantsData){
              	var variant3 = variantsData[key].variant3;
              	var variant3_id_type = variantsData[key].variant3_id_type;
              	var variant3_type = variantsData[key].variant3_type;

              	if(variant3_id_type != ''){
              		var variantExist = $('.vc_3').find('ul li[data-id="'+variant3+'"]').length;
              		if(variantExist == 0){
              			$('.vc_3').find('ul').append('<li data-id="'+variant3+'"><a href="#">'+variant3+'</a></li>');
              		}
              	}

              }

              var initV1_value = variantsData[0].variant1;
              var initV2_value = variantsData[0].variant2;
              var initV3_value = variantsData[0].variant3;

              $('.vc_1').find('ul li[data-id="'+initV1_value+'"] a').trigger('click');
              $('.vc_2').find('ul li[data-id="'+initV2_value+'"] a').trigger('click');
              $('.vc_3').find('ul li[data-id="'+initV3_value+'"] a').trigger('click');
              $('.vc_1').find('ul li[data-id="'+initV1_value+'"] a').trigger('click');

              var selectedColor = getQueryString('variantcolor');
              $('.vc_1').find('ul li[data-id="'+selectedColor+'"] a').trigger('click');

            });

} // end get product detail

// --------------------------  PRODUCTS DETAIL -------------------------//


// ----- GET ----- //

// PBS: used at checkout.php and the popover
// which is not a good practise..
// added step var to knwo where we are

// store the id of boards to mark the button on the details page as "added to cart"
var surfboards_id_on_cart = [];

// create an object to store cart info to use elsewhere
var cart_info = {};
//cart_info.shipping_country_code = '';

//alert('no credentials v3');

function service_GetCart( step ){

	//alert();

	console.log('getting cart at step: '+step);

    //console.log('service_GetCart for the checkout.php and popover');    

    $.ajax({
    	url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
    	method: 'GET',
    	// using cookies may make the bellow unnecessary
    	// FIXME
    	// it is still needed - the API does not work well only with token
    	// the issue is that when adding the item to the cart, the token was not sent..
    	/*
        xhrFields: {
        	withCredentials: true
        },
        beforeSend: function(xhr){
        	xhr.withCredentials = true;
        },
        */
        crossDomain: true,
        context: document.body

      }).done(function(data) {

        //console.log( data );

        // set cookie if no token
        if( Cookies.get('token') == "" ){

            console.log('setting token: '+'/'+data.token);
            Cookies.set('token', '/'+data.token );

        }

        var currency = data.currency;
        var id_cart = data.id_cart;
        var shipping = data.shipping;
        var shipping_text = data.shipping_text;
        var shipping_alt_text = data.shipping_alt_text;
        var subtotal = data.subtotal;
        var tax = data.tax;
        var total = data.total;
        var items = data.items;
        var nrOfItems = items.length;
        var promoCodes = data.promocodes;
        var totalQty = 0;
        var totalgiftvouchers = data.totalgiftvouchers;
        var discount = data.discount;

        $('.cos_products').empty();
        $('.cpl_body').empty();
        $('.cci_insertedpromocodes').empty();


        $('.cos_products').attr('id', 'cart_'+id_cart);
        $('.cos_products').attr('data-id_cart', id_cart);
        $('.cos_totalprice .ccirr_currency').html(currency.symbol);
        $('.cos_totalprice .ccirr_totalprice').html(total.toFixed(2));

		//currency iso and symbol
		$('.currency-symbol').text(currency.symbol);
		$('.currency-iso').text(currency.iso);

        //$('#payment-row').text(data.payment_gateway);

        window.payment_gateway = data.payment_gateway;

        cart_info.shipping_country_code = data.shipping_info.ship_country;
        cart_info.id_shipping_method = data.shipping_info.id_shipping_method;
        cart_info.total = data.total;  

        //--------------------------------------------------------------------------------------------------------------

		// --- CHECKOUT FINAL, TOTAIS

		if( shipping > 0 ){

			console.log('shipping > 0');

			shipping_text = shipping;
			$('#checkout-shipping-row > .currency-symbol').show();
			$('#checkout-shipping-row > .currency-iso').show();

		} else {

			console.log('shipping < 0');

			$('#checkout-shipping-row > .currency-symbol').hide();
			$('#checkout-shipping-row > .currency-iso').hide();

		}

		totalgiftvouchers = Number(totalgiftvouchers);
		if(totalgiftvouchers=='0'){
			$('.totalgiftvouchers').closest('.ccir_row').hide();
		} else {
			$('.totalgiftvouchers').closest('.ccir_row').show();
		}

		if(promoCodes.length=='0'){
			$('.totalpromocode').closest('.ccir_row').hide();
		} else {
			if( Number(discount)>0 ){
				$(".ccir_row .totalpromocode").html(discount);
				$('.totalpromocode').closest('.ccir_row').show();
			}
		}

		for(var key in promoCodes){
			$('.cci_insertedpromocodes').append('<div class="div_promocode"> <span class="promocode_name">'+promoCodes[key].name+'</span> - <span class="promocode_description">'+promoCodes[key].description+'</span>  <a class="cpl_deletepromocode" href="#">delete</a><br></div>');
		}

		var total_global_itens = 0;

		for(var key in items){
			var id_product = items[key].id_product;
			var id_producttype = items[key].id_producttype;
			var id_variant = items[key].id_variant;
			var img = items[key].img;
			if( items[key].type != 'customboard' )
				var name = items[key].name;
			else
				var name = 'custom order surfboard';
			//alert( name);
			var qtdreadonly = items[key].qtdreadonly;
			var qty = items[key].qty;
			var sku = items[key].sku;
			var totalprice = items[key].totalprice;
			var type = items[key].type;
			var unitprice = items[key].unitprice;
			var description = items[key].description;
			var discount_value = items[key].discount_value;
			var discount_unitprice = items[key].discount_unitprice;
			totalQty = Number(totalQty)+Number(qty);

            //console.log( totalQty );

            total_global_itens += Number( qty );

            //PBS: is surfboard? if so, change the button, storing the id´s of the surfboards on cart on a array
            if( id_producttype == 1 ){

            	surfboards_id_on_cart.push( id_product );

            }

            var id_producttypeName;
            var productUrl;
            if(id_producttype=='1'){
            	id_producttypeName = 'surfboard';
            	productUrl = '/?page=shopsurfboarddetail&id='+id_product+'&lang='+sLang;
            } else if(id_producttype=='2'){
            	id_producttypeName = 'accessories';
            	productUrl = '/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=accessories&lang='+sLang;
            } else if(id_producttype=='3'){
            	id_producttypeName = 'apparel';
            	productUrl = '/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel&lang='+sLang;
            } else if(id_producttype=='4'){
            	id_producttypeName = 'custom surfboard';
            	productUrl = '#';
            }


            var descriptionString = '';
            for(var key in description){
            	var nameDesc = description[key].name;
            	var value = description[key].value;
            	var id = description[key].id;
            	if ( nameDesc=="Surfboard Model" ){
            		var test = nameDesc.split(" ");
            		nameDesc = test[1];	
            	}
            	
            	descriptionString += '<span class="'+id_product+'_'+key+'_'+id+'" data-id="'+id+'"><strong>'+nameDesc+':</strong> '+value+'</span>';
            }
            descriptionString += '<span><strong>Qty:</strong> '+qty+'</span>';


            //$('.t_nrofitems').html(items.length);

            $('.t_nrofitems').html( total_global_itens );

            $('.t_subtotal').html(subtotal);
            $('.t_tax').html(tax);

            // define the cost of shipping
            //$('.t_shippingtext').html('here: '+shipping_text);                       

            if( shipping_text=="Free Shipping" ){

            	$(".t_shippingtext_currency_iso").hide();
            	$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').hide();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').hide();
            	$('.t_shippingtext').html( shipping_alt_text ); 

            }else{

            	$(".t_shippingtext_currency_iso").show();
            	$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').show();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').show();
            	$('.t_shippingtext').html( shipping_text );

            }
            
            $('.t_total').html(total.toFixed(2));
            $('.totalgiftvouchers').html(totalgiftvouchers);
            // ------------------------ //

           var img_minicart = "";
           if( img.indexOf("cart-images") != -1 ) {
			img_minicart = "img-minicart";
		}

            $('.cos_products').append('																\
            	<div class="cos_item cartproduct product-'+id_product+'" id="'+id_product+'" data-id_product="'+id_product+'" data-id_producttype="'+id_producttype+'" data-qty="'+qty+'" data-id_variant="'+id_variant+'">	\
            		<div class="col-xs-3 col-sm-3 hidden-xs cart-product-img-col">															\
            			<div class="cosi_img">														\
            				<a href="'+productUrl+'">												\
            					<img src="'+img+'" class="img-responsive '+img_minicart+'" style="width:50px;">							\
            				</a>																	\
            			</div>																		\
            		</div>																			\
            		<div class="col-xs-9 col-sm-6">															\
            			<div class="cpl_productdesc">												\
            				<p class="cplpd_ref">'+sku+'</p>										\
            				<p class="cplpd_name">'+name+'</p>										\
            				<p class="cplpd_aditionalinfo">'+descriptionString+'</p>				\
            			</div>																		\
            		</div>																			\
            		<div class="col-xs-3 col-sm-3 cart-product-price-col">															\
            			<div class="cpl_deleteproduct_wrapper">										\
            				<a href="#"><i class="glyphicon glyphicon-remove"></i></a>						\
            			</div>																		\
            		<div class="cosi_subtotal">													\
            		<span class="subtotal_label">Sub-Total</span>\
            		<br>\
            		<span class="subtotal_value">'+totalprice+'</span>\
            	</div>																		\
            	</div>																			\
            	<div class="clear_both">&nbsp;</div>											\
            	</div>\
            	'); 



            var cplItem = $('.cplitem_dummiecontainer .cpl_item').clone();
            cplItem.attr('data-id_product', id_product);
            cplItem.attr('data-id_producttype', id_producttype);
            cplItem.attr('data-qty', qty);
            cplItem.attr('data-id_variant', id_variant);

		// Verifica se a imagem gerada eh da custom-order
		if( img.indexOf("cart-images") != -1 ) {
			cplItem.find('.cpl_img img').addClass("img-cart");
		}else{
			cplItem.find('.cpl_img img').removeClass("img-cart");
		}

            cplItem.find('.cpl_img img').attr('src', img);
            cplItem.find('.cpl_img a').attr('href', productUrl);
            cplItem.find('.cplpd_ref').html(sku);
            cplItem.find('.cplpd_name').html(name);
            cplItem.find('.cplpd_aditionalinfo').html(descriptionString);
            cplItem.find('.cpl_pricecurrency').html(currency.symbol);
            cplItem.find('.cpl_pricevalue').html(unitprice);
            if( discount_value>0 ){
            	cplItem.find('.cpl_oldpricevalue').html(discount_unitprice+'<br>');
            }
            cplItem.find('.cplqs_value input').val(qty);
            cplItem.find('.cplh_totalcurrency').html(currency.symbol);
            cplItem.find('.cplh_totalprice').html(totalprice);

            if(qtdreadonly=='true'){
            	cplItem.find('.cpl_quantityselect').attr('qtdreadonly', true).addClass('qtdreadonly_true');
            }

            $('.cpl_body').append(cplItem);
            $('.bmc_nrofitems').html(totalQty);
          }

        checkGoToCheckoutButton();

        // PBS 06.2016: we need the id´s of surfboard on cart to be loaded first, then do a match
        $(document).trigger('cart-loaded');

        // PBS 11.2016
        // set cookie if no token
        if( Cookies.get('token') == "" ){
            console.log('setting token: '+'/'+data.token);
            Cookies.set('token', '/'+data.token );
        }

        //----------------------------------------------------------------------
        // if this is step 02 of the checkout
        // check the address defined on the API
        // and assign it to the form       

        // ONLY AFTER COUNTRIES BEING LOADED       

        // TO-DO: find another way to know that we are on the end of the checkout process
        // location may be another
        //if( window.location.pathname == '/index.php' && data.shipping_info.id_shipping_method ){
        var page = getQueryString('page');

        if( page == 'checkoutfinal' && data.shipping_info.id_shipping_method ){

        	//alert( 'page: '+page );
        	
			// ok, here we must defined the address on the form, and trigger the change to be listened..
			//$('#delivery-option-home').prop('checked', true).change();
			$('#delivery-option-home').trigger('click');

			//------------------------------------------------------------------
			// assign country 		
	        
	        getCountrys().then( function(){

	        	$('#ship_country').val( data.shipping_info.ship_country ).change();	        		        

	        	service_GetShippingMethod().then( function(){	        	

	        		console.log('i got shipping methods defined.');

	        		console.log('now set the choosen one: '+cart_info.id_shipping_method);

					//$('.shipping_method').val( cart_info.id_shipping_method );//.change();

					//return false;

	        		// now that we have countries defined, let´s listen to changes.
					$(document).on('change', 'form.checkout_final:not(#id_shipping_method)', function(e){						

						//console.log('form.checkout_final has changed, so calling the service_GetCheckoutInfo() at services.js');
					    service_GetCheckoutInfo(e);

					});		        		

	        	})

	        	if( data.shipping_info.ship_state ){
	        		
	        		getStates( data.shipping_info.ship_country ).then( function(){

						$('#ship_state').val( data.shipping_info.ship_state );

	        		})

	        	}

	        })

	        //------------------------------------------------------------------

        }else if( window.location.pathname == '/index.php' && data.shipping_info.id_shipping_method == "" ){

        	console.log( 'checkout step 2, but no shipping method is defined' );	

        	getCountrys();

			$(document).on('change', 'form.checkout_final:not(#id_shipping_method)', function(e){						

				//console.log('form.checkout_final has changed, so calling the service_GetCheckoutInfo() at services.js');
			    service_GetCheckoutInfo(e);

			});	        	

        }else{

        	console.log('none of the above verified..');

        }             

        //----------------------------------------------------------------------


      }).fail( function(xhr, textStatus, errorThrown){

        //console.log('get cart failed:'+ xhr, textStatus, errorThrown);

        $( document ).trigger('cart-loaded');

      });
    }











//console.log('loaded and working..!');

function service_AddToCart(id_product, id_producttype, id_variant, qty, elementTrigger){

	//console.log('service_AddToCart in the house! and arguments are: '+id_product+', '+id_producttype+', '+ id_variant+', '+ qty+', '+ elementTrigger);

    //return;

    var json = [
    {
    	id_product: ''+id_product+'',
    	id_producttype: ''+id_producttype+'',
    	id_variant: ''+id_variant+'',
    	qty: ''+qty+'',
    	type: 'product',
    	token: Cookies.get('token').replace('/','')
    }
    ];
    $.ajax({
    	url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
    	method: 'POST',
    	data: JSON.stringify(json),
    	contentType: 'application/json',
    	dataType: 'json',
    	xhrFields: {
    		withCredentials: true
    	},
    	crossDomain: true,
    	context: document.body
    }).done(function(data) {

    	//console.log('bellow is reponse of add to cart:');
    	//console.log(data);
    	//console.log( data.token );

    	// this is needed, also on other sites
    	if( Cookies.get('token') == "" )
    		Cookies.set('token', '/'+data.token );

    	service_GetCart();

    	if(elementTrigger!=undefined){
    		if(!elementTrigger.hasClass('prevent_showcart')){
    			var isCartOpen = $('.mycart_contents').attr('data-open');
    			if(isCartOpen == 'false'){
    				$('.btn_mycart').trigger('click');
    			}
    		}
    	} else {
    		var isCartOpen = $('.mycart_contents').attr('data-open');
    		//console.log( isCartOpen );
    		if(isCartOpen == 'false'){
    			$('.btn_mycart').trigger('click');
    		}
    	}

    	checkGoToCheckoutButton();
    });
  }



  function service_DeleteFromCart(id_product, id_producttype, id_variant, qty){
  	var json = [
  	{
  		id_product: ''+id_product+'',
  		id_producttype: ''+id_producttype+'',
  		id_variant: ''+id_variant+'',
  		qty: ''+qty+'',
  		type: 'product',
  		token: Cookies.get('token').replace('/','')
  	}
  	];

  	$.ajax({
  		url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
  		method: 'DELETE',
  		data: JSON.stringify(json),
  		contentType: 'application/json',
  		dataType: 'json',
  		xhrFields: {
  			withCredentials: true
  		},
  		crossDomain: true,
  		context: document.body
  	}).done(function(data) {
  		service_GetCart();
  		checkGoToCheckoutButton();

  		$( document ).trigger('cart-loaded');

  		//console.log('cart-loaded');

  		//console.log( 'before: '+surfboards_id_on_cart );

  		surfboards_id_on_cart = jQuery.grep( surfboards_id_on_cart, function(value) {
  			return value != id_product;
  		});

  		//console.log( 'after: '+surfboards_id_on_cart );

  	})
  }

  function checkGoToCheckoutButton(){
  	var nrOfItemsInCart = $('.checkout_productlist .cpl_body .cartproduct').length;
  	if(nrOfItemsInCart==0){
  		$('.securechckout_big').hide();
  	} else {
  		$('.securechckout_big').show();
  	}
  }



  $(function(){
	// ----- POST ----- //
	//$(document).on('click', '.addtocart', function(e){
		$(document).on('click', '#btn-add-to-cart', function(e){
			e.preventDefault();
			var t = $(this);
			var id_product = Number(t.attr('data-id_product'));
			var id_producttype = Number(t.attr('data-id_producttype'));
			var id_variant = t.attr('data-variant');
			var qty = Number(t.closest('.sldi_addtocart').find('.addproduct_qty').val());
			var isSingleQty = t.hasClass('addtocart_singleqty');
			if(isSingleQty){
				qty=1;
			}

			service_AddToCart(id_product, id_producttype, id_variant, qty);

			setTimeout(function(){
				$('.mycart_contents').stop().fadeOut(300, function(){
					$('.mycart_contents').attr('data-open', 'false');
				});
			}, 3500);

		});

	// ----- DELETE ----- //
	//$(document).on('click', '.cpl_deleteproduct', function(e){
		$(document).on('click', '.cpl_deleteproduct_wrapper .glyphicon-remove, .cpl_deleteproduct', function(e){
			e.preventDefault();
			var t = $(this);
			var item = t.closest('.cartproduct');
			var id_product = item.attr('data-id_product');
			var id_producttype = item.attr('data-id_producttype');
			var id_variant = item.attr('data-id_variant');
			var qty = item.attr('data-qty');

			t.remove();
			item.fadeOut(100);
			service_DeleteFromCart(id_product, id_producttype, id_variant, qty);
		});
	});


//when? - checkout_final.php
function service_GetCheckoutInfo(e){

	//return 0;
	//console.log('returning');	

	//console.log( e );

	var formData = $('.checkout_final').serializeArray();
	var formDataArray;
	var formDataString = '{ '
	for(var key in formData){
		var name = formData[key].name;
		var value = formData[key].value;
		formDataString += '"'+name+'": "'+value+'", ';
	}

	//Cookies.get('token')
	formDataString += '"token" : "'+Cookies.get('token').replace('/','')+'", ';

	formDataString = formDataString.slice(0, -2);
	
	formDataString += ' }'
	
	formDataArray = jQuery.parseJSON(formDataString);


	var useShippingAddressForBilling = $('.shipbillingaddresscheck input').prop('checked');

	if(useShippingAddressForBilling){

		formDataArray.bill_address1 = formDataArray.ship_address1;
		formDataArray.bill_address2 = formDataArray.ship_address2;
		formDataArray.bill_city = formDataArray.ship_city;
		formDataArray.bill_company_name = formDataArray.ship_company_name;
		formDataArray.bill_country = formDataArray.ship_country;
		formDataArray.bill_instructions = formDataArray.ship_instructions;
		formDataArray.bill_state = formDataArray.ship_state;
		formDataArray.bill_zipcode = formDataArray.ship_zipcode;

	}

	// remove shipping_method se for escolhido pickup my order
	if( $("input[name=delivery-option]:checked").val() == "pick-up" ){
		formDataArray["id_shipping_method"]="";
		$(".coconfirm_clientdetails_inner .cci_titleleft").text("You're Picking up your order from:");
	// remove id_pickuplocation se nao for escolhido pickup my order
}else{
	formDataArray["id_pickuplocation"]="";
	$(".coconfirm_clientdetails_inner .cci_titleleft").text("We're going to send your order to:");
}

//if(e.delegateTarget.activeElement.tagName!='BODY' || e.delegateTarget.activeElement.tagName!='body'){
	// if not body..? why and when?
	//if(e.delegateTarget.activeElement.tagName!='BODY' || e.delegateTarget.activeElement.tagName!='body'){
	if( 1 == 1 ){

		//console.log('getting checkout info, and delegate target was not body. - this is called 4 times?');

	$.ajax({
		//url: sUrlShop+'/api/v1/shop/carts/checkout?lang='+sLang,
		url: sUrlShop+'/api/v1/shop/carts/checkout'+Cookies.get('token'),
		method: 'POST',
		data: JSON.stringify(formDataArray),
		contentType: 'application/json',
		dataType: 'json',
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		context: document.body
	}).done(function(data) {

		console.log('response of service_GetCheckoutInfo:');
		console.log(data);

		var currency = data.currency;
		var id_cart = data.id_cart;
		var shipping = data.shipping;
		var shipping_text = data.shipping_text;
		var shipping_alt_text = data.shipping_alt_text;
		var subtotal = data.subtotal;
		var tax = data.tax;
		var total = data.total;
		var items = data.items;
		var nrOfItems = items.length;
		var promoCodes = data.promocodes;
		var giftvouchers = data.giftvouchers;
		var totalgiftvouchers = data.totalgiftvouchers;




		if(shipping>0){

			console.log('shipping > 0');

			shipping_text = shipping;
			$('.t_shippingtext_currency').show();
			$('.t_shippingtext_currency_iso').show();
		} else {
			$('.t_shippingtext_currency').hide();
			$('.t_shippingtext_currency_iso').hide();
		}

		totalgiftvouchers = Number(totalgiftvouchers);

		if(totalgiftvouchers=='0'){
			$('.totalgiftvouchers').closest('.ccir_row').hide();
		} else {
			$('.totalgiftvouchers').closest('.ccir_row').show();
		}


		$('.cos_products').attr('id', 'cart_'+id_cart);
		$('.cos_products').attr('data-id_cart', id_cart);
		$('.cos_totalprice .ccirr_currency').html(currency.symbol);
		$('.cos_totalprice .ccirr_totalprice').html(total.toFixed(2));
			// --- CHECKOUT FINAL, TOTAIS
			//$('.t_nrofitems').html(items.length);
	        //$('.t_nrofitems').html( total_global_itens );
	        $('.t_subtotal').html(subtotal);
	        $('.t_tax').html(tax);
	        $('.t_shippingtext_currency').html(currency.symbol);
	        $('.t_shippingtext_currency_iso').html(currency.iso);	
	        
	        if( shipping_text=="Free Shipping" ){
				
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').hide();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').hide();
				$('.t_shippingtext').html(shipping_alt_text);

			}else{

				$('.t_shippingtext').closest('.ccirr_right').find('.currency-symbol').show();
				$('.t_shippingtext').closest('.ccirr_right').find('.currency-iso').show();
				$('.t_shippingtext').html(shipping_text);

			}

	        $('.totalgiftvouchers').html(totalgiftvouchers);
	        $('.t_total_currency').html(currency.symbol);
	        $('.t_total').html(total.toFixed(2));
			// ------------------------ //

			// must be done after the country is select from the API
			if($(e.target).hasClass('shippingmethodtrigger')){
				service_GetShippingMethod();
			}

			var selectedShipingMethod = data.shipping_info.id_shipping_method;
			$('.shipping_method').val(selectedShipingMethod);




			$('.giftvoucher_insertedcodes').empty();
			for(var key in giftvouchers){
				var code = giftvouchers[key].code;
				var value = giftvouchers[key].value;
				$('.giftvoucher_insertedcodes').append('<span>'+code+'</span> - $<span>'+value+'</span><br>');
			}


			var shipping_info = data.shipping_info;
			var ship_address1 = shipping_info.ship_address1;
			var ship_city = shipping_info.ship_city;
			var ship_zipcode = shipping_info.ship_zipcode;
			var ship_state_name = shipping_info.ship_state_name;
			var ship_country_name = shipping_info.ship_country_name.ship_country_name;

			$('.finalcheckout_address').html('		\
				<span class="cci_subtitle">Address: </span><span>'+ship_address1+'</span><br>			\
				<span class="cci_subtitle">Zip Code: </span><span>'+ship_zipcode+'</span><br>			\
				<span class="cci_subtitle">City: </span><span>'+ship_city+'</span><br>					\
				<span class="cci_subtitle">State: </span><span>'+ship_state_name+'</span><br>			\
				<span class="cci_subtitle">Country: </span><span>'+ship_country_name+'</span><br>		\
				');

			
			console.log('before the loop');

			$.each( items, function(){

				console.log('inside the loop');
				console.log(this);	

				$('.product-'+this.id_product+' .subtotal_value').text( this.totalprice );

			})

		});
}else{
	$.ajax({
		url: sUrlShop+'/api/v1/shop/carts'+Cookies.get('token'),
		method: 'GET',
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		context: document.body
	}).done(function(data) {
		var currency = data.currency;
		$('.cos_totalprice .ccirr_currency').html(currency.symbol);
		$('.t_shippingtext_currency').html(currency.symbol);
		$('.t_shippingtext_currency_iso').html(currency.iso);
		$('.t_total_currency').html(currency.symbol);
		$('.t_total_currency_iso').html(currency.iso);
	});	
}
}

// this can only happen after the country is defined
// and after the shipping method is defined..

//$(document).on('change', 'form.checkout_final:not(#id_shipping_method)', function(e){	
/*
$(document).on('change', '#id_shipping_method', function(e){	

	console.log('form.checkout_final has changed, so calling the service_GetCheckoutInfo() at services.js');
	service_GetCart();
    service_GetCheckoutInfo(e);

});
*/





function service_GetShippingMethod(){

	$('.shipping_method').empty();

    // added and empty option to not add price of shipping
    $('.shipping_method').append('<option value="">please select</option>');

    var t = $(this);
	//var wrapper = t.closest('.calculateshipping_wrapper');
	var wrapper = t.closest('.shipping_address');
	
	/*
	var ship_country = wrapper.find('.country_wrapper select').val();
	var ship_state =  wrapper.find('.state_wraper select').val();
	var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
	*/
	
	var ship_country =  $('#ship_country option:selected').val();
	console.log( 'shipping country is: '+ship_country );
	var ship_state =  $('#ship_state option:selected').val();
	var ship_zipcode = wrapper.find('.zipcode_wraper input').val();
	
	return $.when(
		
		$.ajax({
			//url: sUrlShop+'/api/v1/shop/carts/shipping_methods?ship_country='+ship_country+'&ship_state='+ship_state+'&ship_zipcode='+ship_zipcode,
			url: sUrlShop+'/api/v1/shop/carts/shipping_methods'+Cookies.get('token')+'?ship_country='+ship_country+'&ship_state='+ship_state+'&ship_zipcode='+ship_zipcode,
			method: 'GET',
			xhrFields: {
	                withCredentials: true
	            },
	                crossDomain: true,
	  		context: document.body
		}).done(function(data) {

			$('.shipping_method').empty();

			for(var key in data){
				var id_shipping_method = data[key].id_shipping_method;
				var name = data[key].name;
				var price = data[key].price;
				$('.shipping_method').append('<option value="'+id_shipping_method+'">'+name+'</option>');
			}

			//$('.shipping_method').change();

			// xpto
			//$('.shipping_method').val( cart_info.id_shipping_method ).change();

			if( cart_info.id_shipping_method )
				$('.shipping_method').val( cart_info.id_shipping_method ).change();
			//else
				//$('.shipping_method').change();


		})

	)	

		

	
}



function getCountrys(){

	console.log('getting countries');
	
	return $.when(

		$.ajax({
			url: sUrl+'/api/v1/countries?lang='+sLang,
			method: 'GET',
			context: document.body
		}).done(function(data) {

			$('.country_wrapper select').empty();

			var data = data.countries;

			for(var key in data){

				var iso = data[key].iso;
				var name = data[key].name;
				var selected = data[key].selected;
				if(selected){
					selected = 'selected'
				} else {
					selected = '';
				}

				$('.country_wrapper select').append('<option value="'+iso+'" '+selected+'>'+name+'</option>');

			}	

			$('.country_wrapper select').trigger('change');

			console.log('countries was loaded');
			
			$( document ).ready( function(){

				$( document ).trigger('countries-loaded')

			})

			//})			

		})		

	)

}

function getStates(iso, target){

    //console.log('getStates()');

	return $.when(

		$.ajax({
			url: sUrl+'/api/v1/countries/'+iso+'/states?lang='+sLang,
			method: 'GET',
			//context: document.body
		}).done(function(data) {

			if(target==undefined){
				$('.state_wraper select').empty();
				$('.state_wraper select').append('<option></option>');
		        //$('#ship_state').change();
		        //console.log( $('#ship_state') );
			} else {
				$('.'+target).empty();
				$('.'+target).append('<option></option>');
			}			

	        var data = data.states;

	        console.log( data );

			for(var key in data){
				var iso = data[key].iso;
				var name = data[key].name;
				if(target==undefined){
					$('.state_wraper select').append('<option value="'+iso+'">'+name+'</option>');
				} else {
					$('.'+target).append('<option value="'+iso+'">'+name+'</option>');
				}
			}// end for

	        //if( data.length > 0 )
	            $('#ship_state').change();

	           if( data.length == 0){
	           	$("#"+target).closest(".state_wraper").fadeOut("slow");
	           }else{
	           	$("#"+target).closest(".state_wraper").fadeIn("slow");	
	           }

	           $( document ).trigger('states-loaded');

		})

	)	

}


    function get_PaymentMethods(){
    	$.ajax({
    		url: sUrlShop+'/api/v1/shop/carts/payment_methods?lang='+sLang,
    		method: 'GET',
    		context: document.body
    	}).done(function(data) {
    		var data = data.payment_methods;
    		for(var key in data){
    			var name = data[key].name;
    			var available = data[key].available;
    			if(available){
    				$('.pm_'+name).show();
    			}
    		}
    	});
    }







    function service_SubmitOrder(){

    //var id_payment_method = $('#id_payment_method').val();
    var id_payment_method = $('#payment_method').val();
    var payment_card_number = $('#cc-number').val();
    var payment_card_name = $('#cc-name').val();
    var payment_card_cvc = $('#cc-cvc').val();
    var payment_card_expiry_month = $('#cc-exp-month').val();
    var payment_card_expiry_year = $('#cc-exp-year').val();
    var stripe_token = $('#stripe-token').val();
    console.log( stripe_token );
    
    //"token" : "'+Cookies.get('token').replace('/','')+'"\

    var submitData = '{														\
    	"id_payment_method":"'+id_payment_method+'",						\
    	"payment_card_number":"'+payment_card_number+'",					\
    	"payment_card_name": "'+payment_card_name+'",						\
    	"payment_card_cvc":"'+payment_card_cvc+'",							\
    	"payment_card_expiry_month": "'+payment_card_expiry_month+'",		\
    	"payment_card_expiry_year":"'+payment_card_expiry_year+'",			\
    	"stripe-token" : "'+stripe_token+'"                                 \
    }';

    $.ajax({
    	url: sUrlShop+'/api/v1/shop/carts/orders'+Cookies.get('token')+'?lang='+sLang,
    	method: 'POST',
    	data: submitData,
    	contentType: 'application/json',
    	dataType: 'json',
    	xhrFields: {
    		withCredentials: true
    	},
    	crossDomain: true,
    	error: function(data){
    		var status = data.status;
    		var message = jQuery.parseJSON(data.responseText).message;
    		$('.submitwindow_error').fadeIn();
    		$('.swe_errormessage').html(message);
    	},
    	context: document.body
    }).done(function(data) {

    	var order_no = data.order_no;
    	$('.sw_ordercode').html(order_no);
    	$('.submitwindow_success').fadeIn();

    	// clear token to get new one.
    	Cookies.set('token', '');
    	console.log('cleared token');

    });
  }

  $(function(){

  	$(document).on('click', '.checkout_submitorder', function(e){
  		e.preventDefault();

        //with stripe this maybe not needed..

        service_SubmitOrder();
		//$('body').addClass('ordersubmited');

		$('.submitwindow').fadeIn();

		$('#checkoutfinal_modal .close').trigger('click');

        //$('#form-checkout-final').submit();

        //console.log('form submited');

      });

  });








  $(function(){
  	$(document).on('change', '.country_wrapper select', function(){
  		var t = $(this);
  		var target = t.attr('data-statetarget');
  		var iso = t.val();
  		getStates(iso, target);
  	});


  	$(document).on('click', '.btn_giftvoucher', function(e){
  		e.preventDefault();
  		var t = $(this);
  		var code = t.closest('.giftvoucher_wrapper').find('.giftvoucher').val();
  		var code = '{ "giftvoucher": "'+code+'" }';

  		$.ajax({
  			url: sUrlShop+'/api/v1/shop/carts/giftvouchers?lang='+sLang,
  			method: 'POST',
  			data: code,
  			contentType: 'application/json',
  			dataType: 'json',
  			xhrFields: {
  				withCredentials: true
  			},
  			crossDomain: true,
  			context: document.body
  		}).done(function(data) {

			//console.log(data);

			service_GetCheckoutInfo(e);
		});
  	});
  });



  function initCFactoryMap(coordinates) {
  	var myLatlng = coordinates;
  	var mapOptions = {
  		center: myLatlng,
  		zoom: 16,
  		scrollwheel: false
  	};
  	var map = new google.maps.Map(document.getElementById('contactsfactory_map'), mapOptions);

  	var marker = new google.maps.Marker({
  		position: myLatlng,
	    /*icon: {
	    	url: 'images/chilli_mapmarker.png',
	    }*/
	  });
  	marker.setMap(map);
  }

  function service_Contacts(){
  	$.ajax({
  		url: sUrlShop+'/api/v1/contacts?lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		var target = $('.contacts_factory');
  		var labelAddress = data.labels.txt_address;
  		var labelPhone = data.labels.txt_sales_phone;
  		var labelEmail = data.labels.txt_email_sales;
  		var labelOpeningHours = data.labels.txt_workinghours;
  		var postalcode = data.postal_code;
  		var city = data.city;
  		var country = data.country;
  		var address = data.address;
  		var phone = data.phone_sales;
  		var email = data.email_sales;
  		var openingHours = data.business_hours;

  		var lat = data.gps_lat;
  		var lng = data.gps_long;
  		var coordinates = new google.maps.LatLng(lat,lng);


  		target.find('.ci_labeladdress').hide().html(labelAddress).fadeIn();
  		target.find('.ci_address').hide().html(address).append(', '+postalcode+' '+city+' - '+country).fadeIn();
  		target.find('.ci_labelphone').hide().html(labelPhone).fadeIn();
  		target.find('.ci_phone').hide().html(phone).fadeIn();
  		target.find('.ci_labelemail').hide().html(labelEmail).fadeIn();
  		target.find('.ci_email').hide().html(email).fadeIn();
  		target.find('.ci_labelwork').hide().html(labelOpeningHours).fadeIn();
  		target.find('.ci_work').hide().html(openingHours).fadeIn();

  		setTimeout(function(){
  			initCFactoryMap(coordinates);
  		}, 1000);
  	});
  }

/* ========================================================================
 *   Surfboard Details
 * ======================================================================== */
 function service_SurfboardModelDetail(){
 	var surfboardmodelId = getQueryString('id');
 	$.ajax({
 		url: sUrl+'/api/v1/surfboardmodels/'+surfboardmodelId+'/build?lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {
 		var id_surfboardmodel = data[0].id_surfboardmodel;
 		var surfboardmodel = data[0].surfboardmodel;
 		var id_brand = data[0].id_brand;
 		var id_sport = data[0].id_sport;
 		var brand = data[0].brand;
 		var images = data[0].img;
 		var wavesize_min = data[0].wavesize.min;
 		var wavesize_max = data[0].wavesize.max;
 		var skilllevel = data[0].skilllevel;
 		var skillString = '';
 		var surfboardmodeltype = data[0].surfboardmodeltype;
 		var description = data[0].description;
 		var img_logo = data[0].img_logo;
 		var technology = data[0].technology;
 		var price = data[0].min_price;
 		var currencySymbol = data[0].currency.symbol;
 		var currencyIso = data[0].currency.iso;
 		var shopavailable = data[0].shopavailable;
 		var features = data[0].features;
 		var img_logo = data[0].img_brand_logo;

 		if( id_sport==undefined ){
 			id_sport="";
 		}

 		if( img_logo!=undefined && img_logo!='' ){
 			$(".surfboardmodel-content .row-img img").attr("src", img_logo);
 		}
 		if( data[0].bottom.img == '' ){
 			//console.log( 'data[0].bottom.length = '+data[0].bottom.length );
 			$('.boardbottomfeatures').remove();
 		} else {
 			var bottomImg = data[0].bottom.img;
 			var bottomText = data[0].bottom.text;
 		}
 		if(data[0].videos.length==0){
 			var videoUrl = '';
 		} else {
 			var videoUrl = data[0].videos[0].url;
			/* ========================================================================
		     *   Assign url to social share
		     * ======================================================================== */
		     $('.social-share-video-link').each(function(){
		     	initial_href = this.href;
		     	final_href = initial_href += videoUrl;
		     	this.href = final_href;
		     });

		   }
		   var standard_dimensions = data[0].standard_dimensions;
		   var other_models = data[0].other_models;
		   if( price=='' ){
		   	$('.bdp_price').remove();
		   }

		/* ========================================================================
	     *   Board Image Slider
	     * ======================================================================== */
	     $('#carousel-surfboardmodel-1 .carousel-indicators').empty();
	     var crslIndex = 0;
	     var screen_width = $(window).width();
	     var img_width;
	     if( screen_width<=400 ){ img_width='370'; }
	     else if( screen_width<=500 ){ img_width='400'; }
	     else if( screen_width<=600 ){ img_width='500'; }
	     else if( screen_width<=700 ){ img_width='600'; }
	     else if( screen_width<=800 ){ img_width='700'; }
	     else if( screen_width<=900 ){ img_width='760'; }
	     else if( screen_width<=1000 ){ img_width='710'; }
	     else if( screen_width<=1100 ){ img_width='800'; }
	     else if( screen_width<=1200 ){ img_width='970'; }
	     else if( screen_width<=1300 ){ img_width='1060'; }
	     else{ img_width=screen_width*0.55555555555556; }

		//var paramUrl = "?or=90&w="+img_width;   
		var paramUrl = "?w=1000&h=340&fit=crop&or=90";

		//style removido no div data-phototype '  style="background:url('+imgUrl+''+paramUrl+'); background-position: center; background-repeat: no-repeat;" '

		if( images.length==undefined ){
			for(var key in images){
				var imgUrl = images[key].img_dynamic;
				var cover = images[key].cover;
				
				if(cover==1){
					$('#carousel-surfboardmodel-1 .carousel-indicators').prepend('						\
						<li data-target="#carousel-surfboardmodel-1" data-slide-to="'+crslIndex+'"></li>\
						');
					$('#carousel-surfboardmodel-1 .carousel-inner').prepend('	\
						<div data-phototype="'+images[key].phototype+'" data-index="'+crslIndex+'" class="item" >\
						<img class="img-responsive" src="'+imgUrl+''+paramUrl+'" style="margin:0 auto; position: relative; top: 50%; transform: translateY(-50%); ">\
						<div class="container">\
						<div class="carousel-caption">\
						<div class="row">\
						<div class=" col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">\
						<div class="caption">\
						\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						');
				} else{
					$('#carousel-surfboardmodel-1 .carousel-indicators').append('						\
						<li data-target="#carousel-surfboardmodel-1" data-slide-to="'+crslIndex+'"></li>																			\
						');
					$('#carousel-surfboardmodel-1 .carousel-inner').append('	\
						<div data-phototype="'+images[key].phototype+'" data-index="'+crslIndex+'" class="item">\
						<img class="img-responsive" src="'+imgUrl+''+paramUrl+'" style="margin:0 auto; position: relative; top: 50%; transform: translateY(-50%); ">\
						<div class="container">\
						<div class="carousel-caption">\
						<div class="row">\
						<div class=" col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">\
						<div class="caption">\
						\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						</div>\
						');
				}

				crslIndex++;
			}
		}else{
			$('.carousel-control').fadeOut(500);
		}
		var setImgNrI = 0;
		$('#carousel-surfboardmodel-1 .carousel-indicators > li').each(function(){
			var t = $(this);
			t.attr('data-slide-to', setImgNrI);
			setImgNrI++;
		});
		$('#carousel-surfboardmodel-1 .carousel-indicators li:first').addClass('active');
		$('#carousel-surfboardmodel-1 .carousel-inner .item:first').addClass('active');


		// --- MISC
		$('.breadcrumb .active').html(surfboardmodel);
		$('.bm_brand').html(brand);
		$('.bm_model').html(surfboardmodel);

		if( price!='' ){
			$('.bm_currency_symbol').html(currencySymbol);
			$('.bm_price').html(price);
			$('.bm_currency_iso').html(currencyIso);
		}else{
			$('.bm_price').html('');
			$('.bm_currency_symbol').fadeOut(500);
			$('.bm_currency_iso').fadeOut(500);
		}	

		$('.row-bm-text p.text').html(description);
		$('.bm_wave_min').html(wavesize_min);
		$('.bm_wave_max').html(wavesize_max);
		


 		/* ========================================================================
	     *   Construction
	     * ======================================================================== */
	     var technology = data[0].construction_type;
	     var technology_text = '';
	     for(var key in technology){	
	     	var technology_name = technology[key].constructiontype;
	     	technology_text += '<li>'+technology_name+'</li>';
	     }
	     $('.bm_technology').html(technology_text);

 		/* ========================================================================
	     *   Fin Setup
	     * ======================================================================== */
	     var fin_setup = data[0].fin_setup;
	     var fin_setup_text = '';
	     for(var key in fin_setup){	
	     	var fin_setup_name = fin_setup[key].name;
	     	if( key==0 ){
	     		fin_setup_text += fin_setup_name;
	     	}else{
	     		fin_setup_text += ', '+fin_setup_name;
	     	}
	     }
	     $('.bm_fin_setup').html(fin_setup_text);

 		/* ========================================================================
	     *   Fin System
	     * ======================================================================== */
	     var finsystem = data[0].finsystem;
	     var finsystem_text = '';
	     for(var key in finsystem){	
	     	var finsystem_name = finsystem[key].name;
	     	if( key==0 ){
	     		finsystem_text += finsystem_name;
	     	}else{
	     		finsystem_text += ', '+finsystem_name;
	     	}

	     }
	     $('.bm_finsystem').html(finsystem_text);

 		/* ========================================================================
	     *   Concave
	     * ======================================================================== */
	     var bottoms = data[0].bottoms;
	     var bottoms_text = '';
	     for(var key in bottoms){	
	     	var bottoms_name = bottoms[key].bottom;
	     	bottoms_text += '<li>'+bottoms_name+'</li>';
	     }
	     $('.bm_bottoms').html(bottoms_text);

 		/* ========================================================================
	     *   Tail Shape
	     * ======================================================================== */
	     var tail_shape = data[0].tail_shape;
	     var tail_shape_text = '';
	     for(var key in tail_shape){	
	     	var tail_shape_name = tail_shape[key].name;
	     	tail_shape_text += '<li>'+tail_shape_name+'</li>';
	     }
	     $('.bm_tail_shape').html(tail_shape_text);

		/* ========================================================================
	     *   Skill Level
	     * ======================================================================== */
	     for(var key in skilllevel){
	     	var skill = skilllevel[key].name;
	     	skillString += skill+', ';
	     }
	     skillString = skillString.slice(0, -2)
	     $('.bm_skilllevel').html(skillString);
	     $('.bdpts_surfboardmodeltype').html(surfboardmodeltype);

		/* ========================================================================
	     *   Technology
	     * ======================================================================== */
	     if(technology.length==0){
	     	$('.bdp_textdesc_technology').remove();
	     } else {
	     	for(var key in technology){
	     		var imgUrl = technology[key].img;
	     		$('.bdp_textdesc_technology .bdp_textdesc_technology_imgs').append('<img src="'+imgUrl+'">');
	     	}
	     }

		/* ========================================================================
	     *   Logo
	     * ======================================================================== */
	     $('.bdp_logo').empty();
		//$('.bdp_logo').append('<img src="'+img_logo+'"></img>');
		$('#model-logo').append('<img src="'+img_logo+'" class="img-responsive">');
		$('.sd_boardname').text(surfboardmodel);
		$('.vhbd_boardname').text(surfboardmodel);

		if( shopavailable > 0 ){
			//$('.bdppl_shop').show().attr('href', '/shop/boards/?model='+id_surfboardmodel);
            	//$('#surfboard-buy-stock-btn').fadeIn().attr('href', '/shop/boards/?model='+id_surfboardmodel);
            	$('#surfboard-buy-stock-btn').css('display','block').attr('href', '/?page=shopsurfboarddetail&model='+id_surfboardmodel);
            }

		/* ========================================================================
	     *   Features
	     * ======================================================================== */
	     for(var key in features){
	     	var imgUrl = features[key].img;
	     	var name = features[key].name;
	     	var value = features[key].value;
	     	$('.bf_list').append('											\
	     		<div class="col-sm-4 col-xs-12">							\
	     		<img src="'+imgUrl+'" class="img-responsive">		\
	     		<p class="bf_featuretitle">'+name+':</p>			\
	     		<p class="bf_feature">'+value+'</p>				\
	     		</div>														\
	     		');
	     }

	     $('.boardbottomfeatures_imgwrapper img').attr('src', bottomImg);
	     $('.bbf_disclaimer').html(bottomText);



		// --- VIDEO
		/*if(videoUrl==''){
			$('.video_home').remove();
		} else {
			var isYoutube = videoUrl.indexOf('youtu') > -1;
			if(isYoutube){
				var videoId = youtube_parser(videoUrl);
				var videoEmbed = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
			} else {
				var vimeoId = videoUrl.split('/');
				vimeoId = vimeoId[vimeoId.length - 1];
				var videoEmbed = '<iframe src="https://player.vimeo.com/video/'+vimeoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
			}
			$('.videoembed_wrapper').html(videoEmbed);
		}*/

		//simple custom order button
		$('#surfboard-custom-order-btn').attr('href','/custom-order?model='+id_surfboardmodel);

		// --- STANDARD DIMENSIONS
		for(var key in standard_dimensions){
			var t = standard_dimensions[key];
			var size = t.length_inches;
			var width = t.width_inches;
			var thickness = t.thickness_inches;
			var volume = t.volume;
			if( t.volume!='' ){
				volume = t.volume+' L';
			}
			var weightRange = t.weight_range;
			var tail = t.tail;
			var finOptions = t.fin_options;
			var length_complete = t.length_complete;
			var currentavailability = t.currentavailability;

			var buyQString = 'id_sport='+id_sport+'&id_brand='+id_brand+'&model='+id_surfboardmodel+'&length='+t.length+'&width='+t.width+'&thickness='+t.thickness;
			//var buyQString = 'model='+id_surfboardmodel+'&length='+length+'&width='+t.width;
			var buyUrl = '/?page=shopsurfboarddetail&'+buyQString;

			if(currentavailability=='0'){
				buyNowHtml = '<a class="btn btn-default btn-customorder" href="/custom-order?'+buyQString+'">Custom Order</div>';
			} else {
				buyNowHtml = '<a class="btn btn-default btn-buynow" href="'+buyUrl+'">Buy Now</div>';
			}
			//var buyNowHtml = '';
			//buyNowHtml = '<a class="sd_buynow" href="'+buyUrl+'">Buy Now</div>';

			$('#table-sizerange table tbody').append('												\
				<tr>																					\
				<td>'+size+'</td>																	\
				<td>'+width+'</td>																	\
				<td>'+thickness+'</td>																\
				<td>'+volume+'</td>																	\
				<td>'+buyNowHtml+'</td>																\
				</tr>																					\
				');
		}
		// ---/ STANDARD DIMENSIONS

		var count = 0;

		for(var key in other_models){
			var t = other_models[key];
			var id_surfboardmodel = t.id_surfboardmodel;
			var img = t.img_dynamic;
			var surfboardmodel = t.surfboardmodel;
			var min_price = t.min_price;
			var brand = t.brand;
			

			if( count<4 ){
				if( img!='' ){
					count ++;
					$('#othermodels .othermodels').append('								\
						<div class="col-sm-3 board text-center">\
						<div class="row">\
						<a href="/boards/detail.php?id='+id_surfboardmodel+'">\
						<div class="col-sm-12">\
						<img src="'+img+'?h=506" class="img-responsive" alt="board">\
						</div>\
						<div class="col-sm-12 brand brand_detail">'+brand+'</div>\
						<div class="col-sm-12 model model_detail">'+surfboardmodel+'</div>\
						</a>\
						</div>\
						</div>\
						');
				}
			}

			
		}
		var widget = $('.othersurfboards');
		otherBoardsInit(widget);


		for(var key in skilllevel){
			var skillId = key;
			$('.skli_'+skillId).find('.skli_active').show();
			$('.skli_'+skillId).find('.skli_inactive').hide();
		}


		wavesize_min = Number(wavesize_min);
		for(var i=wavesize_min;i<=wavesize_max;i++){
			var divNr = i+1;
			$('.sws_wrapper .sws_'+divNr).find('.sws_inactive').hide();
			$('.sws_wrapper .sws_'+divNr).find('.sws_active').show();
		}

		$('.bmcb').empty();
		if( shopavailable>0 ){
			$('.bmcb').append('\
				<div class="col-sm-6 align-right">\
				<a href="/shop/boards/?model="'+surfboardmodelId+'" class="btn btn-default bm_button">Buy Stock</a>\
				</div>\
				<div class="col-sm-6 align-left">\
				<a href="/custom-order/?model="'+surfboardmodelId+'" class="btn btn-default bm_button">Custom Order</a>\
				</div>\
				');
		}else{
			$('.bmcb').append('\
				<div class="col-sm-6 col-sm-offset-3">\
				<a href="/custom-order/?model="'+surfboardmodelId+'" class="btn btn-default bm_button">Custom Order</a>\
				</div>\
				');
		}

		//$('.bmcb .align-right a').attr('href', '/shop/boards/?model='+surfboardmodelId );
		//$('.bmcb .align-left a').attr('href', '/custom-order/?model='+surfboardmodelId );
	});
}











function service_BlogList(){

	$.ajax({
		url: sUrl+'/api/v1/cms/zones/45/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		//console.log( data );

		for(var key in data){

			var id_cmsconteudo = data[key].id_cmsconteudo;
			var title = data[key].hptitle;
			var postDate = data[key].dt_publication.en;
			var postResume = data[key].hpresume.substring(0, 100)+' (...)';
			var multimedia = data[key].multimedia[0];
			if(multimedia!=undefined){
				var multimediatype = multimedia.multimediatype;
				var multimediaContent = '';
				if(multimediatype=='Image'){
					var img = multimedia.filename;
					multimediaContent = '<img src="'+img+'" class="img-responsive" style="width:100%">';
				} else if(multimediatype=='URL'){
					var videoUrl = multimedia.url;
					var isYoutube = videoUrl.indexOf('youtu') > -1;
					var embed = '';
					if(isYoutube){
						var videoId = youtube_parser(videoUrl);
						var embed = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
					} else {
						var vimeoId = videoUrl.split('/');
						vimeoId = vimeoId[vimeoId.length - 1];
						var embed = '<iframe src="https://player.vimeo.com/video/'+vimeoId+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
					}
					multimediaContent = embed;
				}
			}

			var hostname = window.location.hostname;

			$('.blog_list_itemcontainer').append('\
				<div class="row blogitem"> \
				<div class="col-md-12">\
				<a href="detail.php?id='+id_cmsconteudo+'">\
				<div class="row">\
				<div class="col-md-9 col-sm-12">\
				<p class="bi_title">'+title+'</p>\
				<p class="bi_postdate">posted on '+postDate+'</p>\
				<p class="bi_textresume">'+postResume+'</p>\
				</div>\
				<div class="col-md-3 col-sm-12">\
				<div class="bi_postdate">share</div>\
				<ul class="social-share-list">\
				<li>\
				<a href="https://www.facebook.com/sharer/sharer.php?u=https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social_fb.png" alt="facebook">\
				</a>\
				</li>\
				<li>\
				<a href="https://twitter.com/intent/tweet?text='+title+' - Chilli Surfboards Blog https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social_twitter.png" alt="twitter">\
				</a>\
				</li>\
				<li>\
				<a href="https://plus.google.com/share?url=https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social-google-plus.png" alt="google plus">\
				</a>\
				</li>\
				<li>\
				<a href="https://www.tumblr.com/share/link?url=https://'+hostname+'/blog/detail.php?id='+id_cmsconteudo+'" target="_blank">\
				<img src="/images/social-tumblr.png" alt="google plus">\
				</a>\
				</li>\
				</ul>\
				</div>\
				</div>\
				'+multimediaContent+'\
				</a>\
				</div>\
				<div class="row">\
				</div>\
				');
		}
	});
}

function service_BlogDetail(){
	var id_cmsconteudo = getQueryString('id');
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/45/objects/'+id_cmsconteudo+'?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var id_cmsconteudo = data[0].id_cmsconteudo;
		var title = data[0].hptitle;
		var postDate = data[0].dt_publication.en;
		var postResume = data[0].hpresume;
		var multimedia = data[0].multimedia[0];
		if(multimedia!=undefined){
			var multimediatype = multimedia.multimediatype;
			var multimediaContent = '';
			if(multimediatype=='Image'){
				var img = multimedia.filename;
				multimediaContent = '<img src="'+img+'" class="img-responsive">';
			} else if(multimediatype=='URL'){
				var videoUrl = multimedia.url;
				var isYoutube = videoUrl.indexOf('youtu') > -1;
				var embed = '';
				if(isYoutube){
					var videoId = youtube_parser(videoUrl);
					var embed = '<iframe src="https://www.youtube.com/embed/'+videoId+'" frameborder="0" allowfullscreen></iframe>';
				} else {
					var vimeoId = videoUrl.split('/');
					vimeoId = vimeoId[vimeoId.length - 1];
					var embed = '<iframe src="https://player.vimeo.com/video/'+vimeoId+'?loop=1" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
				}
				multimediaContent = embed;
			}
		}

		$('.breadcrumb .active').text(title);

		$('.blog_list_itemcontainer').prepend('						\
			<div class="blogitem">									\
			<p class="bi_title">'+title+'</p>					\
			<p class="bi_postdate">'+postDate+'</p>				\
			<p class="bi_textresume">'+postResume+'</p>			\
			'+multimediaContent+'								\
			</div>													\
			');
	});
}












function submitToNewsletter(mail) {
	var email = '{ "email": "'+mail+'" }';
	$.ajax({
		url: sUrl+'/api/v1/subscribers?lang='+sLang,
		method: 'POST',
		data: email,
		contentType: 'application/json',
		dataType: 'json',
		xhrFields: {
			withCredentials: true
		},
		crossDomain: true,
		context: document.body
	}).done(function(data) {

		//console.log(data);

		if(data.subscribe == 'OK'){
			//$('#newsletter-sign-up-heading').text('You will be the first to know!');
			$('.submit_mailinglist_message').fadeIn(1300);
		}

	});
}
$(function(){
	$(document).on('click', '.ml_submit', function(){

		//alert('here');

		var email = $('.maillist_input').val();
		var isEmailValid = validateEmail(email);
		if(isEmailValid){
			submitToNewsletter(email);
			$('.submit_mailinglist').fadeOut(600);
		} else {
			$('.maillist_input').addClass('invalid_field');
			//var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
			//$('.maillist_input').addClass('animated wobble').one(animationEnd, function() {
		    //    $('.maillist_input').removeClass('animated wobble');
		    //});
			//$('.maillist_input').closest('.submit_mailinglist').addClass('invalid_field');
		}
	});
	$(document).on('submit', '.submit_mailinglist', function(e){
		e.preventDefault();
	});
	$(document).on('focusin', '.maillist_input', function(){
		$(this).removeClass('invalid_field');
		//$(this).closest('.submit_mailinglist').removeClass('invalid_field');
	});
});




















function home_getProducts(){

	$.ajax({
		url: sUrl+'/api/v1/shop/products/summary?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var itemsI = 0;

		var loops = 0;

        // holds the build html
        var html = '';

        // on the second row, cols change place, as according to the design
        var push_img = '';
        var pull_text = '';

        for(var key in data){

        	itemsI++;

        	var surfboardmodel = data[key].surfboardmodel;
        	var img = data[key].img.deck;
        	var currency = data[key].currency;
        	var price = data[key].price;
        	var subtitle = data[key].subtitle;
        	var id_surfboard = data[key].id_surfboard;
        	var id_producttype = data[key].id_producttype;

        	var destination = '';
			//if(id_producttype=='1' && id_producttype=='4'){ PBS says: WTF????
				if( id_producttype == '1'){
					destination = '/shop/boards/detail.php?id='+id_surfboard;
				} else {
					destination = '/index.php?page=shopaccessoriesdetail&id='+id_surfboard;
				}

            // PBS: build first row
            if( loops == 0 ){

            	html = '<div class="row">';

            }

            html +=
            '<div class="col-sm-6 shop-display-item">\
            <div class="row">\
            <div class="col-sm-5 '+push_img+' col-xs-6 shponlc_prodpic">\
            <a href="'+destination+'">\
            <img src="'+img+'" class="img-responsive">\
            </a>\
            </div>\
            <div class="col-sm-7 '+pull_text+' col-xs-6">\
            <h1>'+surfboardmodel+'</h1>\
            <p class="shop-display-details">'+subtitle+'</p>\
            <p class="shop-display-price">'+price+' </p>\
            <p class="currency-iso"></p>\
            <a href="'+destination+'" class="btn btn-default btn-130x30">buy now</a>\
            </div>\
            </div>\
            </div>';

            // close actual row and add new
            if( loops == 1 ){

            	html += '</div><div class="row border-top">';

                //push_img = 'col-sm-push-7';
                //pull_text = 'col-sm-pull-5';

              }

              loops++;

		} // end for

        // close open row
        html += '</div>';

        $('#shop-display-placeholder-surfboards').append( html );

      });

    // use same code for accessories and apparel
    // using data-section on the clicked item

    // cache ajax data
    var stored_data = [];

    $('#tab-accessories, #tab-apparel').on('click', function(e) {

    	var section = $(this).data('section');

        //console.log( section );

        var loops = 0;

        // holds the build html
        var html = '';

        // on the second row, cols change place, as according to the design
        var push_img = '';
        var pull_text = '';

        // return cached response or get fresh results
        return stored_data[section] || $.ajax({

        	url: sUrl + '/api/v1/shop/'+section+'?top=4',
        	method: 'GET',
        	context: document.body

        }).done(function (data) {

        	//console.log('getting new data');

        	stored_data[section] = data;

        	var itemsI = 0;

        	for (var key in data) {

        		var id_product = data[key].id_product;
                //var id_brand = data[key].id_brand;

                var brand = data[key].brand;

                var productName = brand+' '+ data[key].name.replace(brand,'');
                var currency = data[key].currency;
                var minprice = data[key].minprice;

                var colors = data[key].variant_colors;
                var nrOfColors = colors.length;
                var tabContent = '';
                var tabNavContent = '';

                if (nrOfColors == 0) {

                	var name = data[key].name;
                	var minprice = data[key].minprice;
                	var mainimg = data[key].mainimg;

                	tabContent += '<div class="tab-pane fade active in" id="prdvariant_' + key + '_1"><img src="' + mainimg + '" class="img-responsive"></div>';
                	tabNavContent = '';

                } else {

                	for (var key2 in colors) {

                        //var name = colors[key2].name;
                        var hexcolor = colors[key2].hexcolor;
                        var img = colors[key2].img;

                        if (key2 == 0) {

                        	var firstActive = 'active in';
                        	var firstLinkActive = 'active';

                        } else {

                        	var firstActive = '';
                        	var firstLinkActive = '';

                        }

                        tabContent += '<div class="tab-pane fade ' + firstActive + '" id="prdvariant_' + key + '_' + key2 + '"><img src="' + img + '" class="img-responsive"></div>';
                        tabNavContent += '<li class="' + firstLinkActive + '"><div class="variant_color" href="#prdvariant_' + key + '_' + key2 + '" data-toggle="tab" style="background-color:' + hexcolor + ';" data-colorname="' + colors[key2].name + '" data-id-product="'+id_product+'">' + key2 + '</div></li>';

                    } // end for key in colors

                } // end else



                // PBS: build first row
                if( loops == 0 ){

                	html = '<div class="row">';

                }

                html +=
                '<div class="col-sm-6 shop-display-item">\
                <div class="row">\
                <div class="col-sm-5 '+push_img+' col-xs-6 shponlc_prodpic">\
                <a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'">\
                <div class="tab-content">'+tabContent+'</div>\
                </a>\
                <div class="variants_nav">\
                <ul>'+tabNavContent+'</ul>\
                </div>\
                </div>\
                <div class="col-sm-7 '+pull_text+' col-xs-6">\
                <h1>'+productName+'</h1>\
                <p class="shop-display-price">'+minprice+' </p>\
                <p class="currency-iso"></p>\
                <a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'" class="btn btn-default btn-130x30" id="link-product-'+id_product+'" data-initial-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop='+section+'">buy now</a>\
                </div>\
                </div>\
                </div>';

                // close actual row and add new
                if( loops == 1 ){

                	html += '</div><div class="row border-top">';

                    //push_img = 'col-sm-push-7';
                    //pull_text = 'col-sm-pull-5';

                  }

                  loops++;

            }// end for key in data

            // close open row
            html += '</div>';

            $('#shop-display-placeholder-'+section).append( html );

        }) // end done

      })


    // PBS - default btn does not have link with variant..
    $(document).on('click', '.variant_color', function(){

    	//console.log( $( this ).data('id-product'));
    	var link = $( '#link-product-' + $( this ).data('id-product') );

    	//console.log( link.data('initial-url') );

        //console.log( $( link ) );

        //console.log( link.prop('data-initial-url') );
        //console.log( link.prop('data', 'initial-url') );

        link.prop('href',$(link).data('initial-url')+'&variantcolor='+$(this).data('colorname') );

      })

  }


  function get_ShopHomeList(){
  	$.ajax({
  		url: sUrl+'/api/v1/shop/surfboards?top=4&lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		for(var key in data){
  			var surfboardmodel = data[key].surfboardmodel;
  			var img = data[key].img.deck;
  			var currency = data[key].currency;
  			var price = data[key].price;
  			var subtitle = data[key].subtitle;
  			var id_surfboard = data[key].id_surfboard;

            // PBS: simplify things!
            $('.shophome_surfboards').prepend('\
            	<div class="col-sm-3">\
            	<a href="/shop/boards/detail.php?id='+id_surfboard+'">\
            	<img src="'+img+'" class="img-responsive center-block">\
            	<h1>'+surfboardmodel+'</h1>\
            	<p>'+subtitle+'</p>\
            	<p class="price">\
            	'+currency.symbol+''+price+'\
            	<span class="currency">'+currency.iso+'</span>\
            	</p>\
            	</a>\
            	</div>\
            	');
          }
        });



  	$.ajax({
  		url: sUrl+'/api/v1/shop/accessories?top=4&lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		for(var key in data){
  			var id_product = data[key].id_product;
  			var id_brand = data[key].id_brand;

  			var name = data[key].name;
  			var currency = data[key].currency;
  			var minprice = data[key].minprice;


  			var colors = data[key].variant_colors;
  			var nrOfColors = colors.length;
			var tabContent = ''; //service_SurfboardModelDetail();
			var tabNavContent = '';

			if(nrOfColors==0){
				var name = data[key].name;
				var minprice = data[key].minprice;
				var mainimg = data[key].mainimg;
				tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img src="'+mainimg+'" class="img-responsive"></div>';
				tabNavContent = '';
			} else {
				for(var key2 in colors){
					var name = colors[key2].name;
					var hexcolor = colors[key2].hexcolor;
					var img = colors[key2].img;


					if(key2==0){
						var firstActive = 'active in';
						var firstLinkActive = 'active';
					} else {
						var firstActive = '';
						var firstLinkActive = '';
					}
					tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img src="'+img+'" class="img-responsive"></div>';
					tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+name+'">'+key2+'</div></li>';
				}
			}

			$('.shophome_accessories').prepend('\
				<div class="col-sm-3">\
				<div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">\
				<a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=accessories" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=accessories">\
				<div class="tab-content">'+tabContent+'</div>\
				<h1>'+name+'</h1>\
				<p class="price">\
				<span>'+currency.symbol+'</span>\
				'+minprice+'<span class="currency"> '+currency.iso+'</span>\
				</p>\
				<div class="variants_nav">\
				<ul>'+tabNavContent+'</ul>\
				</div>\
				</a>\
				</div>\
				</div>\
				');
		}

        /*
		setListItemHeight($('.si_img'));
		setTimeout(function(){
			setListItemHeight($('.si_img'));
		}, 100);
		*/

	});



  	$.ajax({
  		url: sUrl+'/api/v1/shop/apparel?top=4&lang='+sLang,
  		method: 'GET',
  		context: document.body
  	}).done(function(data) {
  		for(var key in data){
  			var id_product = data[key].id_product;
  			var id_brand = data[key].id_brand;

  			var name = data[key].name;
  			var currency = data[key].currency;
  			var minprice = data[key].minprice;


  			var colors = data[key].variant_colors;
  			var nrOfColors = colors.length;
  			var tabContent = '';
  			var tabNavContent = '';

  			if(nrOfColors==0){
  				var name = data[key].name;
  				var minprice = data[key].minprice;
  				var mainimg = data[key].mainimg;
  				tabContent += '<div class="tab-pane fade active in" id="prdvariant_'+key+'_1"><img src="'+mainimg+'" class="img-responsive"></div>';
  				tabNavContent = '';
  			} else {
  				for(var key2 in colors){
  					var name = colors[key2].name;
  					var hexcolor = colors[key2].hexcolor;
  					var img = colors[key2].img;


  					if(key2==0){
  						var firstActive = 'active in';
  						var firstLinkActive = 'active';
  					} else {
  						var firstActive = '';
  						var firstLinkActive = '';
  					}
  					tabContent += '<div class="tab-pane fade '+firstActive+'" id="prdvariant_'+key+'_'+key2+'"><img src="'+img+'" class="img-responsive"></div>';
  					tabNavContent += '<li class="'+firstLinkActive+'"><div class="variant_color" href="#prdvariant_'+key+'_'+key2+'" data-toggle="tab" style="background-color:'+hexcolor+';" data-colorname="'+name+'">'+key2+'</div></li>';
  				}
  			}

  			$('.shophome_apparel').prepend('\
  				<div class="col-sm-3">\
  				<div class="shopitem" data-id_product="'+id_product+'" data-id_brand="'+id_brand+'">\
  				<a href="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel" data-url="/index.php?page=shopaccessoriesdetail&id='+id_product+'&shop=apparel">\
  				<div class="tab-content">'+tabContent+'</div>\
  				<h1>'+name+'</h1>\
  				<p class="price"><span>'+currency.symbol+'</span>'+minprice+'<span class="currency"> '+currency.iso+'</span></p>\
  				<div class="variants_nav">\
  				<ul>'+tabNavContent+'</ul>\
  				</div>\
  				</a>\
  				</div>\
  				</div>\
  				');
  		}




        /*
		setListItemHeight($('.si_img'));
		setTimeout(function(){
			setListItemHeight($('.si_img'));
		}, 100);
		*/
	});
  }


//gets miscellaneous pages
function service_miscpage(id){
	$.ajax({
		url: sUrl+'/api/v1/cms/zones/47/objects/'+id+'?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {
		var headerImg = data[0].multimedia[0].filename;
		var hptitle = data[0].hptitle;
		var atext = data[0].atext;

		$('#chilli_carousel .item img').attr('src', headerImg);
		$('.breadcrumb .active').text(hptitle);
		$('.carousel-caption p').text(hptitle);
		$('.miscpage_container .miscpage_container_inner').append(atext);
	});
}


//PBS 05.2016: instagram sprays
function instagram_sprays(){

    //alert('olé!');

    $.ajax({
    	type: "GET",
    	dataType: "jsonp",
    	cache: false,
        //url: "https://api.instagram.com/v1/users/2326332367/media/recent/?access_token=43180423.0a91f54.5bc57c4d6f1b42289181b61676747075",
        //@pedrosilvashaperbuddy
        url: "https://api.instagram.com/v1/users/2326332367/media/recent/?access_token=3314912590.dd3641f.b0a044bae2bd4e8688db295404f4d42d",
        success: function(response) {

            //console.log( response );
            
            //first row
            var instagram_sprays_html = '<div class="row">';

            $.each(response.data, function(){

                //console.log(this.images);
                //console.log(this.likes);

                instagram_sprays_html +=
                '<div class="col-md-4 col-sm-3 col-xs-6 instagram-sprays-col">\
                <a href="'+this.link+'" target="_blank">\
                <div class="instagram-sprays-inner">\
                <div class="instagram-sprays-overlay">'+this.likes.count+'<i class="glyphicon glyphicon-heart"></i></div>\
                <img src="'+this.images.standard_resolution.url+'" class="img-responsive" alt="instagram spray">\
                </div>\
                </a>\
                </div>';

              })

            //close open row
            instagram_sprays_html += '</div>';

            $('#instagram-sprays-container').append( instagram_sprays_html );

            var loops = 0;

            //some anim..
            $.each( $('.instagram-sprays-col'), function(){

            	//console.log( this );

            	loops++;

            	$(this).delay( loops * 500).fadeIn();

            })

          }
        });

  }





/**
 *
 * HOME PAGE
 *
 */

//	Load BY TYPE and BY BRAND in shop boards section
function service_LoadTypeBrand(){
	$.ajax({
		url: sUrl+'/api/v1/shop/surfboards/filters?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			if( data[key].name == "By Sport" ){

        		//$.each( data[key].item, function(){
        			for(var key2 in data[key].item){
        				$('#by-type-dropdown').append(
        					'<li>\
        					<a href="#" data-filter-id="'+key2+'" data-filter-by="type" data-filter-value="'+data[key].item[key2]+'">\
        					'+data[key].item[key2]+'\
        					</a>\
        					</li>'
        					);
        			}

        		}

        	}

        });

	$.ajax({
		url: sUrlShop+'/api/v1/brands?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			$('#by-brand-dropdown').append(
				'<li>\
				<a href="#" data-filter-id="'+key+'" data-filter-by="brand" data-filter-value="'+data[key]+'">\
				'+data[key]+'\
				</a>\
				</li>'
				);
			
		}

	});

}

// change by type or by brand
//$('#by-type-dropdown a, #by-brand-dropdown a').on('click', function( e ){
	$(document).on('click', '#by-type-dropdown a, #by-brand-dropdown a', function(e){	
		e.preventDefault();
		var _this = $(this);

    // remove previous
    _this.closest('ul').find('.active').removeClass('active');
    _this.addClass('active');
    
    build_shop_boards_carousel( $('#by-type-dropdown a.active').data('filter-id'), $('#by-brand-dropdown a.active').data('filter-id') );
  })

// function for load the surfboardmodels
function build_shop_boards_carousel( type_id, brand_id ){
	$('#boards-carousel').fadeOut(500 , function(){

		var item_content = '';
		var id_sport = '';
		var id_brand = '';
		var board_loops = total_board_loops = item_loops = 0;   

		if( type_id != undefined ){
			id_sport = type_id;
		}
		
		if( brand_id != undefined ){
			id_brand = brand_id;
		}

		$.ajax({
			url: sUrl+'/api/v1/surfboardmodels?id_sport='+id_sport+'&id_brand='+id_brand+'&order=latestmodel&lang='+sLang,
			method: 'GET',
			context: document.body
		}).done(function(data) {
			
			if( data.length == 0 ){
				item_content += 
				'<div class="col-xs-12 col-md-4 board text-center">\
				<div class="row">\
				<a href="#">\
				<div class="board-btn-wrapper">\
				<!-- button -->\
				</div>\
				<div class="col-xs-12">\
				<!-- img -->\
				</div>\
				<div class="col-xs-12 brand">\
				<!-- brand -->\
				</div>\
				<div class="col-xs-12 model">\
				<!-- model -->\
				</div>\
				<div class="col-xs-12 price">\
				<!-- price -->\
				</div>\
				</a>\
				</div>\
				</div>';
			}

			var board_loops_max = 2;
			var data_key_max = 14;
			if( $(window).width()<577 ){
				board_loops_max = 0;
				data_key_max = 5;
			}

	        //$.each( data, function(){     
	        	for(var key in data){   

	        		if( key <= data_key_max ){
		            //start new slide / item if board_loops == 0
		            if( board_loops == 0 && item_loops ==  0 )
		            	item_content += '<div class="item active">';
		            else if( board_loops == 0 )
		            	item_content += '<div class="item">';

		            // image board
		            var img_surfboard = "/assets/img/surfboard.png";
		            //console.log( data[key].img_dynamic );
		            if( data[key].img_dynamic != '' && data[key].img_dynamic != undefined ){
		            	img_surfboard = data[key].img_dynamic;
		            }
		            
		            // currency symbol and currency iso
		            var currency_symbol = currency_iso = '';
		            var min_price = '';
		            if( data[key].min_price != '' ){
		            	currency_symbol = data[key].currency.symbol;
		            	currency_iso = data[key].currency.iso;
		            	min_price = '<small>From</small> '+data[key].min_price;
		            }

		            item_content += 
		            '<div class="col-xs-12 col-md-4 board text-center">\
		            <div class="row">\
		            <a href="/shop/boards/?model='+data[key].id_surfboardmodel+'">\
		            <div class="board-btn-wrapper">\
		            <button class="btn btn-primary">SHOP BOARD</button>\
		            </div>\
		            <div class="col-xs-12">\
		            <img src="'+img_surfboard+'?h=506" class="-img-responsive" alt="board">\
		            </div>\
		            <div class="col-xs-12 brand">\
		            '+data[key].brand+'\
		            </div>\
		            <div class="col-xs-12 model">\
		            '+data[key].surfboardmodel+'\
		            </div>\
		            <div class="col-xs-12 price">\
		            '+currency_symbol+' '+min_price+' '+currency_iso+'\
		            </div>\
		            </a>\
		            </div>\
		            </div>';

		            board_loops ++;
		            total_board_loops ++;

		            // if board_loops > 1 close slide
		            // or reached the end
		            if( board_loops > board_loops_max || total_board_loops == data.length ){

		            	board_loops = 0;
		            	item_loops ++;
		            	item_content += '</div>';
		            }   
		          }         
		        }
		        $('#shop-boards-carousel-row-inner #boards-carousel .carousel-inner').html( item_content );
	        //console.log( item_content );

	        var indicators = '';
	        for( var i= 0; i < item_loops; i++ ){
	        	if( i == 0 )
	        		indicators += '<li data-target="#boards-carousel" data-slide-to="'+i+'" class="active"></li>';
	        	else
	        		indicators += '<li data-target="#boards-carousel" data-slide-to="'+i+'"></li>';
	        }
	        $('#shop-boards-carousel-controls .carousel-indicators').html( indicators ); 
	      })

        /*if( filter_type == 'brand' ){
            var boards = ['02.png','02.png','02.png','02.png','02.png','02.png'];
        }
        else{
            var boards = ['01.png','01.png','01.png','01.png','01.png','01.png','01.png','01.png','01.png','01.png'];
          }*/

        //console.log( item_content );

        //$('#shop-boards-carousel-row-inner #boards-carousel .carousel-inner').html( item_content );

    })// end fadeOut    
$('#boards-carousel').fadeIn();
}

/**
 *
 * BRANDS PAGE
 *
 */

//	Carrega as Brands na página brands.php 
function service_Brands(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/59/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			if( data[key].ordemnp!='' ){	

				$('#brands-logo-row').append('\
					<a href="'+data[key].hpurl+'" data-hptitle="'+data[key].hptitle+'">\
					<div class="col-xs-6 col-sm-2 brand_flip text-center">\
					<img class="img-responsive" src="'+data[key].bannerimg+'" alt="" style="margin: 0 auto; margin-top:50%; transform:translateY(-50%);">\
					<h1 style="transform: translateY(-150%);">'+data[key].hptitle+'</h1>\
					</div>\
					</a>\
					');

			}

		}

		var brand_flip_width = $('.brand_flip:first').width();
		$('.brand_flip').each(function(){
			$(this).css('height', brand_flip_width);
		})

	});
}
$(document).on('mouseover', '.brand_flip', function(){
	var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
	$(this).addClass('animated flipInY').one(animationEnd, function() {
		$(this).removeClass('animated flipInY');
	});
})

/**
 *
 * BOARDS PAGE
 *
 */

// Carrega todas as pranchas de todas as marcas (4 pranchas por cada marca)
function service_getBoardsPage(){

	$.ajax({
		url: sUrlShop+'/api/v1/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var id_brand = "";
		var count = 0;
		var count_max = 5;

		$('#surfboards-container .board-container').fadeOut(1000).empty();

		for (var key in data) {

		// image board
		var img_surfboard = "/assets/img/surfboard.png";
		if( data[key].img_dynamic != '' && data[key].img_dynamic != undefined ){
			img_surfboard = data[key].img_dynamic;
		}

          // logo image
          var img_logo = "/assets/img/brands/rusty.png";
          if( data[key].img_brand_logo != '' && data[key].img_brand_logo != undefined ){
          	img_logo = data[key].img_brand_logo;
          }

          // min price
          var min_price = '';
          var currency_symbol = '';
          var currency_iso = '';
          if( data[key].min_price != '' ){
          	currency_symbol = data[key].currency.symbol;
          	currency_iso = data[key].currency.iso;
          	min_price = '<small>From</small> '+data[key].min_price;
          }

          if( data[key].id_brand != id_brand ){
          	id_brand = data[key].id_brand;
          	count = 1;
				//console.log( '1: '+count );
				$('#surfboards-container .board-container').append('\
					<div class="brand-content col-sm-12" data-id_brand="'+data[key].id_brand+'" id="brand_'+data[key].id_brand+'">\
					<div class="row text-center">\
					<img class="brand-img" src="'+img_logo+'" alt="Logo">\
					</div>\
					<div class="row">\
					<h2 class="spacemono">'+data[key].brand+'</h2>\
					</div>\
					<div class="row board-row-content"></div>\
					<div class="row text-center">\
					<button class="btn btn-primary">View All Available Models</button>\
					</div>\
					</div>\
					<div class="clearfix">&nbsp;</div>').hide().fadeIn(1000);
			}
			if( data[key].id_brand == id_brand ){
				count ++;
				//console.log( '2: '+count );
				if( count <= count_max ){
					$('#surfboards-container .board-container .brand-content[data-id_brand='+data[key].id_brand+'] .board-row-content').append('\
						<div class="col-sm-3 board text-center">\
						<div class="row">\
						<a href="/boards/detail.php?id='+data[key].id_surfboardmodel+'">\
						<div class="col-sm-12">\
						<img src="'+img_surfboard+'?h=506" class="img-responsive" alt="board">\
						</div>\
						<div class="col-sm-12 brand spacemono">'+data[key].brand+'</div>\
						<div class="col-sm-12 model spacemono">'+data[key].surfboardmodel+'</div>\
						<div class="col-xs-12 price spacemono">'+currency_symbol+' '+min_price+' '+currency_iso+'</div>\
						</a>\
						</div>\
						</div>\
						').hide().fadeIn(1000);
				}
				/*<div class="col-sm-3 board text-center">\
		                        <div class="row">\
		                            <a href="#">\
		                                <div class="col-sm-12">\
		                                    <img src="/assets/img/homepage-boards-carousel/01.png" class="-img-responsive" alt="board">\
		                                </div>\
		                                <div class="col-sm-12 brand">brand</div>\
		                                <div class="col-sm-12 model">model</div>\
		                            </a>\
		                        </div>\
		                        </div>\*/
		                      }


		                    }

		                  });
}

 /* ========================================================================
 * Carrega apenas as pranchas de uma marca específica ao clicar no botao 
 * ======================================================================== */
 function service_getBoardsPage_detail(_id_brand){

 	$.ajax({
 		url: sUrlShop+'/api/v1/surfboardmodels?id_brand='+_id_brand+'&lang='+sLang,
 		method: 'GET',
 		context: document.body
 	}).done(function(data) {
 		var id_brand = "";
 		var count = 0;

 		$('#surfboards-container .board-container .brand-content[data-id_brand='+_id_brand+']').fadeOut("slow").empty();
 		for (var key in data) {
			/* ========================================================================
			 * image board
			 * ======================================================================== */
			 var img_surfboard = "/assets/img/surfboard.png";
			 if( data[key].img_dynamic != '' && data[key].img_dynamic != undefined ){
			 	img_surfboard = data[key].img_dynamic;
			 }

            	// min price
            	var min_price = '';
            	var currency_symbol = '';
            	var currency_iso = '';
            	if( data[key].min_price != '' ){
            		currency_symbol = data[key].currency.symbol;
            		currency_iso = data[key].currency.iso;
            		min_price = '<small>From</small> '+data[key].min_price;
            	}

            	// logo image
            	var img_logo = "/assets/img/brands/rusty.png";
            	if( data[key].img_brand_logo != '' && data[key].img_brand_logo != undefined ){
            		img_logo = data[key].img_brand_logo;
            	}
            	if( data[key].id_brand != id_brand ){
            		id_brand = data[key].id_brand;
            		count = 1;
            		$('#surfboards-container .board-container .brand-content[data-id_brand='+_id_brand+']').append('\
            			<div class="row text-center">\
            			<img class="brand-img" src="'+img_logo+'" alt="">\
            			</div>\
            			<div class="row">\
            			<h2 class="spacemono">'+data[key].brand+'</h2>\
            			</div>\
            			<div class="row board-row-content"></div>\
            			<div class="row text-center">\
            			</div>\
            			<div class="clearfix">&nbsp;</div>')
				//.hide().fadeIn(1000);
				.stop().slideDown("slow");
			}
			if( data[key].id_brand == id_brand ){
				count ++;
				$('#surfboards-container .board-container .brand-content[data-id_brand='+_id_brand+'] .board-row-content').append('\
					<div class="col-sm-3 board text-center">\
					<div class="row">\
					<a href="/boards/detail.php?id='+data[key].id_surfboardmodel+'">\
					<div class="col-sm-12">\
					<img src="'+img_surfboard+'?h=506" class="img-responsive" alt="board">\
					</div>\
					<div class="col-sm-12 brand spacemono">'+data[key].brand+'</div>\
					<div class="col-sm-12 model spacemono">'+data[key].surfboardmodel+'</div>\
					<div class="col-xs-12 price spacemono">'+currency_symbol+' '+min_price+' '+currency_iso+'</div>\
					</a>\
					</div>\
					</div>\
					')
				//.hide().fadeIn(1000);
				.stop().slideDown("slow");
			}
		}
	});
 }
// Quando carrega no botao para exibir mais pranchas dessa marca
$(document).on('click', '.brand-content button.btn.btn-primary', function(){
	var _this = $(this);
	var id_brand = _this.closest('.brand-content').attr('data-id_brand');
	if( id_brand!=undefined ){
		service_getBoardsPage_detail(id_brand);
		//_this.fadeOut(1000);	
		_this.slideUp("3000");
	}
	
})

/**
 *
 * ABOUT PAGE
 *
 */

// Carrega as informações no About
function service_getAbout(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/563?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#about-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o título do texto
			$('.about-text .text h1').hide().text( data[key].atitle ).fadeIn();
			// Aplica o conteudo do texto
			$('.about-text .text .p_text').hide().html( data[key].atext ).fadeIn();
			// Aplica a imagem de fundo
			$('.about-img img').hide().attr('src', data[key].multimedia[0].filename).fadeIn();

		}
	});

}

/**
 *
 * SHIPPING PAGE
 *
 */

// Carrega as informações no Shipping
function service_getShipping(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/562?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#shipping-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o título do texto
			$('#shipping-container h1.atitle').hide().text( data[key].atitle ).fadeIn();
			// Aplica o conteudo do texto
			$('#shipping-container .atext').hide().html( data[key].atext ).fadeIn();
			// Aplica a imagem de fundo
			$('.about-img img').hide().attr('src', data[key].multimedia[0].filename).fadeIn();

		}
	});

}

/*
 *
 *	STORES PAGE
 *
 */

// Carrega as informações na pagina de stores (conteudo esta estatico mas carrega o mapa)
function initCStoresMap(coordinates) {
	var myLatlng = coordinates;
	var mapOptions = {
		center: myLatlng,
		zoom: 16,
		scrollwheel: false
	};
	var map = new google.maps.Map(document.getElementById('stores1_map'), mapOptions);
	var marker = new google.maps.Marker({
		position: myLatlng,
	});
	marker.setMap(map);
}
function service_getStores(){
	setTimeout(function(){
		var coordinates = new google.maps.LatLng('38.716308','-9.166803');
		initCStoresMap(coordinates);
	}, 1000);
}


/**
 *
 * RETURN AND POLICY PAGE
 *
 */

// Carrega as informações no Return and Policy
function service_getReturnPolicy(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/577?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#warranty-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#warranty-container .atext').hide().html( data[key].atext ).fadeIn();
			
		}
	});

}

/**
 *
 * WARRANTY POLICY PAGE
 *
 */

// Carrega as informações no Warranty Policy
function service_getWarrantyPolicy(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/578?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#warranty-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#warranty-container .atext').hide().html( data[key].atext ).fadeIn();
			
		}
	});

}

/**
 *
 * PRIVACY POLICY PAGE
 *
 */

// Carrega as informações no Privacy and Policy
function service_getPrivacyPolicy(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/58/objects/599?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#warranty-container h1.cross').hide().text( data[key].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#warranty-container .atext').hide().html( data[key].atext ).fadeIn();
			
		}
	});

}

/**
 *
 * HOME PAGE
 *
 */

// Carrega as informações da loja na homepage
function service_getTheBaseStores(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/56/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// Aplica o Título principal da pagina
			$('#the-base-stores-container h1.cross').hide().text( data[0].hptitle  ).fadeIn();	
			// Aplica o conteudo do texto
			$('#the-base-stores-container .atext').hide().html( data[0].atext ).fadeIn();
			// Aplica o url no botao "view all locations"
			if( data[0].hpurl!=null ){
				$('#the-base-stores-container .btn-viewalllocations').attr('href', data[0].hpurl);
			}else{
				//$('#the-base-stores-container .btn-viewalllocations').attr('href', '/stores.php');
				$('#the-base-stores-container .btn-viewalllocations').fadeOut(500);
			}
			// Aplica a imagem de fundo
			//$('#the-base-stores-container #shop-carousel-row img').hide().attr('src', data[0].multimedia[0].filename).fadeIn();
			$('#the-base-stores-container #shop-carousel-row .carousel-inner').empty();
			$('#the-base-stores-container #shop-carousel-row #carousel-controllers-wrapper .carousel-indicators').empty();
			if( data[0].multimedia.length==1 ){
				$('#the-base-stores-container #shop-carousel-row .carousel-inner').append('\
					<!-- carousel item 1 -->\
					<img src="'+data[0].multimedia[0].filename+'" class="img-responsive" alt="shop">\
					<!--/ carousel item 1 -->\
					');
				$("#shop-carousel-row #carousel-controllers-wrapper").remove();
			}else if( data[0].multimedia.length>1 ){
				for(key in data[0].multimedia){
					
					var itemclass = "";
					if( key == 0 ){
						itemclass = "active";
					}

					// Insere a imagem no slider
					$('#the-base-stores-container #shop-carousel-row .carousel-inner').append('\
						<div class="item '+itemclass+'"><img src="'+data[0].multimedia[key].filename+'" class="img-responsive" alt="shop"></div>\
						');
					// Insere o indicador no slider
					$('#the-base-stores-container #shop-carousel-row #carousel-controllers-wrapper .carousel-indicators').append('\
						<li data-target="#shop-carousel-row" data-slide-to="'+key+'" class="'+itemclass+'"></li>\
						');	

				}
			}
		}
	});

}

// Carrega as imagens no carousel header
function service_getCarouselHeader(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/57/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		for(var key in data){

			// HOMEPAGE: TEXTO DO BANNER
			if( data[key].hptitle!=undefined ){
				var string_home = data[key].hptitle;		//var string_home = "only online | 25% | off on all JR Surfboards";
				string_home = string_home.replace('||','<br>');
				var string_home_array = string_home.split('|');
				var string_home_final = '';
				for (key2 in string_home_array) {
					if( key2==1 ){
						if( string_home_array[key2]!='' ){
							string_home_final += '<span class="text2">'+string_home_array[key2]+'</span>';
						}
					}else{
						string_home_final += '<span class="text1">'+string_home_array[key2]+'</span>';
					}
				}
			}
			// end HOMEPAGE: TEXTO DO BANNER

			var itemclass = "";
			if( key == 0 ){
				itemclass = "active";
			}



			$('#carousel-header .carousel-inner').append('\
				<!--carousel item -->\
				<div class="item '+itemclass+'" style="background:url('+data[key].bannerimg+'); background-size:cover; background-position: center center;">\
				<div class="container">\
				<div class="carousel-caption">\
				<div class="row">\
				<div class=" col-xs-12 col-sm-8 col-sm-offset-1 col-md-6 col-md-offset-2">\
				<div class="caption">\
				'+string_home_final+'\
				</div>\
				</div>\
				</div>\
				</div>\
				</div>\
				</div>\
				<!--/carousel item-->');

			$('#carousel-header #carousel-controllers-wrapper ol').append('\
				<li data-target="#carousel-header" data-slide-to="'+key+'" class="'+itemclass+'"></li>\
				');
		}

	});

}

//	Carrega as Brands na página home 
function service_BrandsHome(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/59/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var count = 0;
		var brands = {};
		brands.ordemhp = [];
		brands.hptitle = [];
		brands.bannerimg = [];
		brands.hpurl = [];
		//var brands_array = new Array(); // [0]-ordemhp  [1]-hptitle  [2]-bannerimg 

		for(var key in data){

			if( data[key].ordemhp!='' ){

				brands.ordemhp.push(data[key].ordemhp);
				brands.hptitle.push(data[key].hptitle);
				brands.bannerimg.push(data[key].bannerimg);
				brands.hpurl.push(data[key].hpurl);
				count ++;

			}

		}

		var aux = 0;
		function ordenarBrands(key2, ordemhp, hptitle, bannerimg, hpurl){
			if( ordemhp >= aux && aux < 6 ){
				$('#brands-logo-row').append('\
					<a href="'+hpurl+'" data-hptitle="'+hptitle+'">\
					<div class="col-xs-6 col-sm-2 brand_flip text-center">\
					<img class="img-responsive" src="'+bannerimg+'" alt="" style="margin: 0 auto; margin-top:50%; transform:translateY(-50%);">\
					<h1 style="transform: translateY(-150%);">'+hptitle+'</h1>\
					</div>\
					</a>\
					');
				aux ++;
			}
		}

		do {
			for(var key2 in brands.ordemhp){
				ordenarBrands(key2, brands.ordemhp[key2], brands.hptitle[key2], brands.bannerimg[key2], brands.hpurl[key2]);	
			}
		}
		while (aux <= 5);


		var brand_flip_width = $('.brand_flip:first').width();
		$('.brand_flip').each(function(){
			$(this).css('height', brand_flip_width);
		})

	});
}

// Carrega as informações dos destaques na homepage
function service_getFeatures(){

	$.ajax({
		url: sUrlShop+'/api/v1/cms/zones/60/objects?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		$('#main-links-first-row').empty();

		for(var key in data){

			var button = '';
			if( data[key].atitle!='' ){
				button = '<a href="'+data[key].hpurl+'" class="btn btn-primary">'+data[key].atitle+'</a>';
			}

			$('#main-links-first-row').append('\
				<!-- imagem destaque '+key+' -->\
				<a href="'+data[key].hpurl+'">\
				<div class="img-hover col-xs-12 col-sm-12 col-md-6">\
				<div class="img-mask">\
				<img height="300px" src="'+data[key].bannerimg+'" class="img-responsive" alt="imagem destaque">\
				</div>\
				<div class="xpto" style="position:absolute; z-index:999; top:0; width:100%; right:15px;">\
				<div class="row">\
				<div class="col-xs-12 text-center" style="position:relative">\
				<div class="main-links-text spacemono">\
				<h1 class="text-center">\
				'+data[key].hptitle+'\
				<br>\
				'+data[key].atext+'\
				</h1>\
				'+button+'\
				</div>\
				</div>\
				</div>\
				</div>\
				</div>\
				</a>\
				<!--/ imagem destaque '+key+' -->\
				');
			
		}
	});

}

/*

Tooltip

$(document).ready(function(){
//$(function(){	
	$('a').each(function(){
		if( $(this).attr('href') == '#' ){
			$(this).attr('title', 'Comming Soon');
			$(this).attr('data-toggle', 'tooltip');
		}
	})

	$('[data-toggle="tooltip"]').tooltip({
		position: {
			my: "left center",
			at: "right+30 center"
		}
	});
});

*/

/*
 *
 *	SHOP Surfboards (Filter Properties) 
 *
 */
// Seta as informacoes de marca e desporto nos modelos para o filtro funcionar dinamicamente
function service_setFilterProperties(){

	$.ajax({
		url: sUrl+'/api/v1/shop/surfboards/filters/surfboardmodels?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		var aux_id_brand = 0;
		var aux_id_sport = 0;

		$('.slfg_items_inner[data-filterdataname=id_surfboardmodel]').empty();

		for(var key in data){
			var label_sport = '';
			var label_brand = '';

			if( data[key].id_brand!=aux_id_brand || data[key].id_sport!=aux_id_sport ){
				aux_id_brand = data[key].id_brand;
				label_brand = '<label class="label_brand" data-id_sport="'+data[key].id_sport+'" data-id_brand="'+data[key].id_brand+'"><span>'+data[key].brand+'</span></label>';
			}

			if( data[key].id_sport!=aux_id_sport ){
				aux_id_sport = data[key].id_sport;
				label_sport = '<label class="label_sport" data-id_sport="'+data[key].id_sport+'"><span>'+data[key].sport+'</span></label>';
			}

			$('.slfg_items_inner[data-filterdataname=id_surfboardmodel]').append('\
				'+label_sport+'																					\
				'+label_brand+'																					\
				<label data-itemsufix="">																		\
				<input class="sblf_filtercheck filterdata" type="checkbox" name="id_surfboardmodel" 		\
				value="'+data[key].id_surfboardmodel+'" 													\
				data-id_sport="'+data[key].id_sport+'" 														\
				data-id_brand="'+data[key].id_brand+'">														\
				'+data[key].surfboardmodel+' 																\
				</label>																						\
				');
			
		}

	});

}



/**
 *
 * CUSTOM ORDER - INFO
 *
 */

// Carrega as informações no Privacy and Policy
function service_getCustomOrderInfo(){

	$.ajax({
		url: sUrl+'/api/v1/shop/texts/customerorderinfo',
		method: 'GET',
		context: document.body
	}).done(function(data) {

		// custom order info
		$(".container-customorder #info .cms-content").html( data[0].texto );
		
	});

}

/**
 *
 * CHECKOUT - ( PAYMENT OPTIONS | SHIPPING OPTIONS | CuSTOMER SERVICE )
 *
 */

// Carrega as informações no Privacy and Policy
function service_getCheckoutTablesInfo(){

	$.ajax({
		url: sUrl+'/api/v1/shop/texts/checkout',
		method: 'GET',
		context: document.body
	}).done(function(data) {

		// 1
		// title
		//$(".checkout_disclaimer .table1_info h3").text();
		// content
		$(".checkout_disclaimer .table1_info .cms-content").html( data[0].texto );
		
		// 2
		// title
		//$(".checkout_disclaimer .table2_info h3").text();
		// content
		$(".checkout_disclaimer .table2_info .cms-content").html( data[1].texto );
		// button
		//$(".checkout_disclaimer .table2_info .cdi_btnwrapper a").attr("src", "/shipping.php");
		//$(".checkout_disclaimer .table2_info .cdi_btnwrapper a").text("Check Shipping Rates");
		
		// 3
		// title
		//$(".checkout_disclaimer .table3_info h3").text();
		// content
		$(".checkout_disclaimer .table3_info .cms-content").html( data[2].texto );
		
	});

}

/**
 *
 * ARTICLE PAGE
 *
 */

// Carrega as informações dos detalhes na pagina do produto (shop)
function service_getArticlePageInfo(){

	$.ajax({
		url: sUrlShop+'/api/v1/shop/texts/articlepage?lang='+sLang,
		method: 'GET',
		context: document.body
	}).done(function(data) {

		// Article Page (Payment and Security)
		$(".sld_paymentandsecurity .cms-content").html( data[0].texto );

		// Article Page (Shipping)
		$(".sld_shipping .cms-content").html( data[1].texto );
		
	});

}